import React, { useCallback, useEffect, useRef, useState } from "react";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import { Link, useNavigate, useBlocker } from "react-router-dom";
import axios from "axios";
import { Popover, Typography } from "@mui/material";
import { IoEyeOutline } from "react-icons/io5";
import CancelIcon from "@mui/icons-material/Cancel";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import { ChevronDown, Plus } from "lucide-react";
import { jwtDecode } from "jwt-decode";
import Card from "../../../components/Card";
import url from "../../../configs/config";
import FocusError from "../../../components/error/error-focus";
import AlertNotificationSimple from "../../../components/alert/alert-notification-simple";
import InputField from "../../../components/input/input-field";
import "react-phone-input-2/lib/style.css";
import Select from "react-select";
import FadeLoaderComponent from "../../../components/loader-component";
import { useMemo } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { IconButton } from "@mui/material";
import { Box, TextField, Tooltip } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { roleTypes } from "../../../data/roleType";
import DatePickerField from "../../../components/input/date-picker-field";
import * as SettingSelector from "../../../store/setting/selectors";
import { useSelector } from "react-redux";

const OrderRequestAdd = () => {
  const alertRef = useRef(null);
  const navigate = useNavigate();
  const [animatingRows, setAnimatingRows] = useState(new Set());
  const [movingProducts, setMovingProducts] = useState(new Set());
  const [dragPopoverAnchor, setDragPopoverAnchor] = useState(null);
  const [dragPopoverOpen, setDragPopoverOpen] = useState(false);
  const alertRefProduct = useRef(null);
  const [loader, setLoader] = useState(true);
  const [errors, setErrors] = useState({});
  const [decodedToken, setDecodedToken] = useState();
  const [vendors, setVendors] = useState([]);
  const [allVendors, setAllVendors] = useState([]);
  const [vendorId, setVendorId] = useState("all");
  const [warehouses, setWarehouses] = useState([]);
  const [isHovered, setIsHovered] = useState(false);
  const token = localStorage.getItem("coyote-token");
  const [orderProducts, setOrderProducts] = useState([]);
  const permissionsWarehouse = useSelector(SettingSelector?.set_permissions);
  const warehouseHasCreatePermission =
    permissionsWarehouse?.warehouse?.create === true;
  const [products, setProducts] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalOrderRecords, setTotalOrderRecords] = useState(0);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 5 });
  const [orderPagination, setOrderPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [globalFilter, setGlobalFilter] = useState("");
  const [orderProductsGlobalFilter, setOrderProductsGlobalFilter] =
    useState("");
  const [selectedProductKeys, setSelectedProductKeys] = useState(new Set());
  const [alert, setAlert] = useState({
    message: "",
    type: "",
    show: false,
    alertFor: "",
  });
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showDiscardModal, setShowDiscardModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const [activePanel, setActivePanel] = useState("none");
  const showGeneralProductsPanel = activePanel === "general";
  const isTable3Open = activePanel === "requested";
  const isRightPanelOpen = activePanel !== "none";

  const [gpSearchText, setGpSearchText] = useState("");
  const [gpProducts, setGpProducts] = useState([]);
  const [gpTotal, setGpTotal] = useState(0);
  const [gpNextOffset, setGpNextOffset] = useState(null);
  const [gpOffset, setGpOffset] = useState(0);
  const [gpLoadingInitial, setGpLoadingInitial] = useState(false);
  const [gpLoadingMore, setGpLoadingMore] = useState(false);
  const [gpSortConfig, setGpSortConfig] = useState({
    key: "productName",
    direction: "asc",
  });

  const [gpSelectedProducts, setGpSelectedProducts] = useState([]);
  const [gpValidationErrors, setGpValidationErrors] = useState({});
  const [gpOptionsJob, setGpOptionsJob] = useState([]);
  const [gpViewItem, setGpViewItem] = useState(null);
  const [gpViewModal, setGpViewModal] = useState(false);
  const gpRequestIdRef = useRef(0);
  const GP_LIMIT = 20;

  const [bulkJobId, setBulkJobId] = useState(null);
  const [gpSelectedJobId, setGpSelectedJobId] = useState(null);
  const [gpSelectedSystemId, setGpSelectedSystemId] = useState(null);
  const [gpSelectedPhaseId, setGpSelectedPhaseId] = useState(null);
  const [gpSystemOptions, setGpSystemOptions] = useState([]);
  const [gpPhaseOptions, setGpPhaseOptions] = useState([]);
  const [gpLoadingSystems, setGpLoadingSystems] = useState(false);

  const [bulkSystemId, setBulkSystemId] = useState(null);
  const [bulkPhaseId, setBulkPhaseId] = useState(null);
  const [bulkSystemOptions, setBulkSystemOptions] = useState([]);
  const [bulkPhaseOptions, setBulkPhaseOptions] = useState([]);

  const [jobSystemsPhasesMap, setJobSystemsPhasesMap] = useState({});
  const [leftWidth, setLeftWidth] = useState(50);
  const [isResizing, setIsResizing] = useState(false);
  const containerRef = useRef(null);

  const startResizing = useCallback((e) => {
    setIsResizing(true);
    e.preventDefault();
  }, []);
  const stopResizing = useCallback(() => setIsResizing(false), []);
  const resize = useCallback(
    (e) => {
      if (isResizing && containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const newWidth = ((e.clientX - rect.left) / rect.width) * 100;
        if (newWidth >= 32 && newWidth <= 75) setLeftWidth(newWidth);
      }
    },
    [isResizing],
  );

  useEffect(() => {
    if (isResizing) {
      window.addEventListener("mousemove", resize);
      window.addEventListener("mouseup", stopResizing);
    } else {
      window.removeEventListener("mousemove", resize);
      window.removeEventListener("mouseup", stopResizing);
    }
    return () => {
      window.removeEventListener("mousemove", resize);
      window.removeEventListener("mouseup", stopResizing);
    };
  }, [isResizing, resize, stopResizing]);

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      hasUnsavedChanges && currentLocation.pathname !== nextLocation.pathname,
  );

  const createProductKey = (product) =>
    `${product.product_id}-${product.product_request_id}-${product.job_id}-${product.system_id}-${product.phase_id}`;

  useEffect(() => {
    const handler = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = "";
        return "";
      }
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [hasUnsavedChanges]);

  useEffect(() => {
    if (blocker.state === "blocked") {
      setShowDiscardModal(true);
      setPendingNavigation(() => blocker.proceed);
    }
  }, [blocker.state]);

  const handleDiscardChanges = useCallback(() => {
    if (blocker.state === "blocked") {
      setHasUnsavedChanges(false);
      setShowDiscardModal(false);
      if (pendingNavigation) {
        pendingNavigation();
        setPendingNavigation(null);
      } else if (blocker.proceed) blocker.proceed();
    }
  }, [blocker.state, pendingNavigation, blocker]);

  const handleCancelDiscard = useCallback(() => {
    if (blocker.state === "blocked") blocker.reset();
    setShowDiscardModal(false);
    setPendingNavigation(null);
  }, [blocker.state, blocker]);

  useEffect(() => {
    setHasUnsavedChanges(orderProducts.length > 0);
  }, [orderProducts]);

  const getExcludedProductIds = () =>
    orderProducts
      .filter((p) => p.product_request_id)
      .map((p) => ({
        product_id: p.product_id,
        product_request_id: p.product_request_id,
        system_id: p.system_id,
        phase_id: p.phase_id,
        job_id: p.job_id,
      }));

  const getLocalDate = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  };

  const formatDateMMDDYYYY = (dateInput) => {
    let date;
    if (typeof dateInput === "string") {
      if (dateInput.includes("-")) {
        const [y, m, d] = dateInput.split("-");
        date = new Date(parseInt(y), parseInt(m) - 1, parseInt(d));
      } else {
        date = new Date(dateInput);
      }
    } else {
      date = new Date(dateInput);
    }
    if (isNaN(date.getTime())) return "Invalid Date";
    return `${String(date.getMonth() + 1).padStart(2, "0")}/${String(date.getDate()).padStart(2, "0")}/${date.getFullYear()}`;
  };

  const [formData] = useState({
    date: getLocalDate(),
    poNumber: "",
    vendorId: "",
    warehouseId: null,
    shipTo: "",
  });

  useEffect(() => {
    if (token && typeof token === "string") {
      try {
        setDecodedToken(jwtDecode(token)?.user);
      } catch (e) {
        console.error(e);
      }
    }
  }, [token]);

  const getWarehouses = async () => {
    try {
      const res = await axios.get(`${url.backendURL}warehouse/all`, {
        headers: { Authorization: `${token}` },
      });
      setWarehouses(res.data.response.data);
    } catch (err) {
      handleError(err, "user-edit");
    }
  };

  const getVendors = async () => {
    try {
      const res = await axios.get(
        `${url.backendURL}vendor/all/product-request`,
        { headers: { Authorization: `${token}` } },
      );
      setVendors(res.data.response.data);
    } catch (err) {
      handleError(err, "order-add");
    }
  };

  const getAllVendors = async () => {
    try {
      const res = await axios.get(`${url.backendURL}vendor/all`, {
        headers: { Authorization: `${token}` },
      });
      setAllVendors(res.data.response.data);
    } catch (err) {
      handleError(err, "order-add");
    }
  };

  const generateSearchableText = (item) => {
    return [
      item.name || item.product_name || item.productName,
      item.manufacturer_name || item.manufacturerName,
      item.model,
      item.sku,
      item.job_name || item.jobName,
      item.system_name || item.systemName,
      item.phase_name || item.phaseName,
      item.site_name || item.siteName,
      item.description,
      item.searchable_text || "",
      item.phaseNames || item.phase_names || "",
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
  };

  const filterOrderProducts = (products, searchValue) => {
    if (!searchValue || searchValue.trim() === "") return products;
    const words = searchValue.toLowerCase().trim().split(/\s+/);
    return products.filter((p) => {
      const textToSearch = [
        p.name,
        p.product_name,
        p.manufacturer_name,
        p.model,
        p.sku,
        p.job_name,
        p.system_name,
        p.phase_name,
        p.site_name,
        p.description,
        p.searchable_text || "",
        p.productName,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      return words.every((w) => textToSearch.includes(w));
    });
  };

  const getPaginatedData = (data, pageIndex, pageSize) =>
    data.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize);

  const [address, setAddress] = useState({ warehouseId: null, shipTo: "" });

  const getWarehouseAddress = async () => {
    try {
      if (!token || !decodedToken) {
        localStorage.removeItem("coyote-token");
        navigate(
          `/${decodedToken?.roles?.some((r) => r.role_type === roleTypes.SUPER_ADMIN) ? "admin" : "user"}/auth/sign-in`,
          { state: { status: "invalid-token" } },
        );
        return;
      }
      const res = await axios.get(`${url.backendURL}order/shipto-address`, {
        headers: { Authorization: `${token}` },
      });
      const d = res.data.response.data;
      formData.shipTo = d?.ship_to;
      formData.warehouseId = d?.warehouse_id;
      setAddress({ shipTo: d.ship_to, warehouseId: d.warehouse_id });
    } catch (_) {}
  };

  const getActiveProductRequests = async (
    page = 0,
    limit = 10,
    search = "",
  ) => {
    try {
      setLoadingProducts(true);
      const excluded = getExcludedProductIds();
      const config = {
        headers: { Authorization: `${token}` },
        params: {
          page: page + 1,
          limit,
          search,
          vendorId: vendorId !== "all" ? vendorId : undefined,
        },
      };
      const res = await axios.post(
        `${url.backendURL}order/active-product-request`,
        { excludeProducts: excluded },
        config,
      );
      const rd = res.data.response;
      const available = (rd.data || []).filter(
        (p) =>
          !orderProducts.some(
            (op) =>
              op.product_id === p.product_id &&
              op.product_request_id === p.product_request_id &&
              (op.system_id === p.system_id ||
                (op.system_id === null && p.system_id === null)) &&
              (op.phase_id === p.phase_id ||
                (op.phase_id === null && p.phase_id === null)) &&
              (op.job_id === p.job_id ||
                (op.job_id === null && p.job_id === null)),
          ),
      );
      setProducts(
        available.map((p) => ({
          ...p,
          isSelected: selectedProductKeys.has(createProductKey(p)),
        })),
      );
      setTotalRecords(rd.total || 0);
    } catch (err) {
      console.error("Error fetching products:", err);
      try {
        const excluded = getExcludedProductIds();
        const res = await axios.get(
          `${url.backendURL}order/active-product-request`,
          {
            headers: { Authorization: `${token}` },
            params: {
              page: page + 1,
              limit,
              search,
              vendorId: vendorId !== "all" ? vendorId : undefined,
              excludeProducts: JSON.stringify(excluded),
            },
          },
        );
        const rd = res.data.response;
        const available = (rd.data || []).filter(
          (p) =>
            !orderProducts.some(
              (op) =>
                op.product_id === p.product_id &&
                op.product_request_id === p.product_request_id &&
                op.system_id === p.system_id &&
                op.phase_id === p.phase_id,
            ),
        );
        setProducts(
          available.map((p) => ({
            ...p,
            isSelected: selectedProductKeys.has(createProductKey(p)),
          })),
        );
        setTotalRecords(rd.total || 0);
      } catch (fe) {
        console.error("Fallback failed:", fe);
      }
    } finally {
      setLoadingProducts(false);
    }
  };

  useEffect(() => {
    if (token && decodedToken)
      getActiveProductRequests(
        pagination.pageIndex,
        pagination.pageSize,
        globalFilter,
      );
  }, [
    pagination.pageIndex,
    pagination.pageSize,
    globalFilter,
    vendorId,
    orderProducts,
    token,
    decodedToken,
  ]);

  useEffect(() => {
    if (token && decodedToken) {
      (async () => {
        await getWarehouseAddress();
        await getVendors();
        await getAllVendors();
        await getWarehouses();
        setLoader(false);
      })();
    }
  }, [token, decodedToken]);

  const [validationErrors, setValidationErrors] = useState();
  const [rateErrors, setRateErrors] = useState({});

  const initialFormValues = useMemo(
    () => ({
      ...formData,
      shipTo: address.shipTo,
      warehouseId: address.warehouseId,
    }),
    [formData, address.shipTo, address.warehouseId],
  );

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    try {
      const items = orderProducts.map((item) => ({
        productId: Number(item.product_id),
        quantity: Number(item.quantity),
        rate: item.rate,
        jobId: item.job_id ? Number(item.job_id) : null,
        productRequestId: item.product_request_id || null,
        systemId: item.system_id ? Number(item.system_id) : null,
        phaseId: item.phase_id ? Number(item.phase_id) : null,
        description: item.description || "",
      }));
      await validationSchemaItem().validate({ items }, { abortEarly: false });
      setValidationErrors();
      const res = await axios.post(
        `${url.backendURL}order/`,
        {
          ...values,
          vendorId: values.vendorId ? Number(values.vendorId) : null,
          items,
        },
        { headers: { Authorization: `${token}` } },
      );
      if (alertRef.current)
        alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      setValidationErrors();
      setAlert({
        message: res.data.message,
        type: "success",
        show: true,
        alertFor: "order-add",
      });
      setHasUnsavedChanges(false);
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
        navigate("/dashboard/app/purchase-order-list");
      }, 2000);
    } catch (err) {
      if (err.name === "ValidationError") {
        const obj = {};
        if (err.errors.includes("Items are required")) {
          setValidationErrors("At least one item is required");
        } else {
          let fallback = "";
          err.inner.forEach(({ path, message }) => {
            const m = path && path.match(/^items\[(\d+)\]\.(.+)$/);
            if (m) {
              const item = orderProducts[Number(m[1])];
              if (item) {
                const k = createProductKey(item);
                if (!obj[k]) obj[k] = {};
                obj[k][m[2]] = message;
              } else {
                fallback = fallback || message;
              }
            } else {
              fallback = fallback || message;
            }
          });
          if (Object.keys(obj).length > 0) {
            setValidationErrors(obj);
            setAlert({ message: "Rate must be greater than 0", type: "danger", show: true, alertFor: "order-add" });
          } else if (fallback) setValidationErrors(fallback);
          else setValidationErrors("Please fill all required fields correctly");
          if (alertRef?.current)
            alertRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
        }
      } else {
        if (alertRef?.current)
          alertRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        handleError(err, "order-add");
      }
    } finally {
      setSubmitting(false);
    }
  };

  const fetchJobSystemsPhases = async (jobId) => {
    if (!jobId) return null;
    if (jobSystemsPhasesMap[jobId]) return jobSystemsPhasesMap[jobId];
    try {
      const res = await axios.get(
        `${url.backendURL}product-request/${jobId}/job/systems-with-phases`,
        { headers: { Authorization: `${token}` } },
      );
      const data = res.data.response.data;
      setJobSystemsPhasesMap((prev) => ({ ...prev, [jobId]: data }));
      return data;
    } catch (_) {
      return null;
    }
  };

  const fetchProductSuggestions = async (
    inputValue,
    selectedProductIds = [],
    keyCol,
    directionCol,
    limit,
    offset,
  ) => {
    try {
      const res = await axios.get(`${url.backendURL}job/products`, {
        headers: { Authorization: `${token}` },
        params: {
          product: inputValue,
          searchKey: keyCol,
          searchDirection: directionCol,
          limit,
          offset,
          vendorId: vendorId !== "all" ? vendorId : undefined,
          excludeProducts: selectedProductIds.length > 0 ? JSON.stringify(selectedProductIds) : undefined,
        },
      });
      const { data, pagination } = res.data.response;
      return {
        products: data.map((p) => ({
          productId: p.product_id,
          productName: p.product_name,
          rate: p.product_cost,
          quantity: 1,
          amount: p.product_cost,
          model: p.product_model,
          manufacturerId: p.manufacturer_id,
          manufacturerName: p.manufacturer_name,
          sku: p.sku,
          inventoryType: p.inventory_type,
          description: p.product_description,
          phases: p.phases,
          phaseNames: p.phase_names,
          searchable_text: p.searchable_text,
          systemId: null,
          phaseId: null,
        })),
        total: pagination.total,
        offset: pagination.offset,
        nextOffset: pagination.nextOffset,
      };
    } catch (error) {
      if (
        error.response?.data?.error === "jwt expired" ||
        error.response?.data?.error === "Unauthorized. User not found"
      ) {
        localStorage.removeItem("coyote-token");
        navigate(
          `/${decodedToken?.roles?.some((r) => r.role_type === roleTypes.SUPER_ADMIN) ? "admin" : "user"}/auth/sign-in`,
          { state: { status: "expired" } },
        );
      }
      return { products: [], total: -1, offset: 0, nextOffset: null };
    }
  };

  const gpCreateKey = (productId, systemId, phaseId) =>
    `${productId}-${systemId || "null"}-${phaseId || "null"}`;

  const gpIsInSelection = (productId, systemId, phaseId) => {
    const k = gpCreateKey(productId, systemId, phaseId);
    return gpSelectedProducts.some(
      (p) => gpCreateKey(p.productId, p.systemId, p.phaseId) === k,
    );
  };

  const gpLoadInitial = async (
    search = "",
    sortKey = "productName",
    sortDir = "asc",
    forcedExcludedList = null,
  ) => {
    setGpLoadingInitial(true);
    gpRequestIdRef.current += 1;
    const rid = gpRequestIdRef.current;
    try {
      const excludedToUse = forcedExcludedList
        ? forcedExcludedList.filter(p => !p.product_request_id).map(p => p.product_id)
        : orderProducts.filter(p => !p.product_request_id).map(p => p.product_id);
      const data = await fetchProductSuggestions(
        search,
        excludedToUse,
        sortKey,
        sortDir,
        20,
        0,
      );
      if (gpRequestIdRef.current !== rid) return;
      const prods = (data?.products || []).map((p) => ({
        ...p,
        jobId: null,
        systemId: null,
        phaseId: null,
        quantity: p.quantity || 1,
        rate: p.rate || 0,
        amount: (p.rate || 0) * (p.quantity || 1),
        phaseNames: p.phaseNames,
      }));
      setGpProducts(prods);
      setGpTotal(data?.total || 0);
      setGpNextOffset(data?.nextOffset || null);
      setGpOffset(0);
    } catch (err) {
      console.error("GP load error:", err);
    } finally {
      if (gpRequestIdRef.current === rid) setGpLoadingInitial(false);
    }
  };

  const gpLoadMore = async () => {
    if (!gpNextOffset) return;
    setGpLoadingMore(true);
    try {
      const data = await fetchProductSuggestions(
        gpSearchText,
        orderProducts.filter(p => !p.product_request_id).map(p => p.product_id),
        gpSortConfig.key,
        gpSortConfig.direction,
        20,
        gpNextOffset,
      );
      if (data?.products?.length > 0) {
        const prods = data.products.map((p) => ({
          ...p,
          jobId: null,
          systemId: null,
          phaseId: null,
          quantity: p.quantity || 1,
          rate: p.rate || 0,
          amount: (p.rate || 0) * (p.quantity || 1),
          phaseNames: p.phaseNames,
        }));
        setGpProducts((prev) => [...prev, ...prods]);
        setGpTotal(data.total || gpTotal);
        setGpNextOffset(data.nextOffset || null);
        setGpOffset(data.offset || gpOffset);
      }
    } catch (err) {
      console.error("GP load more error:", err);
    } finally {
      setGpLoadingMore(false);
    }
  };

  const gpSelectRow = (product, onlySelect = false) => {
    setGpSelectedProducts((prev) => {
      const k = gpCreateKey(
        product.productId,
        product.systemId,
        product.phaseId,
      );
      const isSel = prev.some(
        (p) => gpCreateKey(p.productId, p.systemId, p.phaseId) === k,
      );
      if (isSel) {
        if (onlySelect) return prev;
        return prev.filter(
          (p) => gpCreateKey(p.productId, p.systemId, p.phaseId) !== k,
        );
      }
      return [
        ...prev,
        {
          ...product,
          quantity: product.quantity || 1,
          rate: product.rate || 0,
          amount: (product.rate || 0) * (product.quantity || 1),
        },
      ];
    });
  };

  const gpUpdateField = (productId, systemId, phaseId, key, value) => {
    const update = (item) => {
      if (
        item.productId !== productId ||
        item.systemId !== systemId ||
        item.phaseId !== phaseId
      )
        return item;
      return {
        ...item,
        [key]: value,
        amount:
          key === "rate"
            ? (parseFloat(value) || 0) * (parseFloat(item.quantity) || 1)
            : key === "quantity"
              ? (parseFloat(item.rate) || 0) * (parseFloat(value) || 0)
              : item.amount,
      };
    };
    setGpSelectedProducts((prev) => prev.map(update));
    setGpProducts((prev) => prev.map(update));
  };

  const gpValidate = () => {
    const errs = {};
    let hasErrors = false;
    gpSelectedProducts.forEach((item) => {
      const k = gpCreateKey(item.productId, item.systemId, item.phaseId);
      errs[k] = {};
      if (!item.quantity || item.quantity <= 0) {
        errs[k].quantity = "Quantity is required";
        hasErrors = true;
      }
      if (
        item.rate === "" ||
        item.rate === null ||
        item.rate === undefined
      ) {
        errs[k].rate = "Rate is required";
        hasErrors = true;
      }
      const hasAnyJSP = item.jobId || item.systemId || item.phaseId;
      const allJSP = item.jobId && item.systemId && item.phaseId;
      if (hasAnyJSP && !allJSP) {
        if (!item.jobId) errs[k].jobId = "Job is required";
        if (!item.systemId) errs[k].systemId = "System is required";
        if (!item.phaseId) errs[k].phaseId = "Phase is required";
        hasErrors = true;
      }
    });
    setGpValidationErrors(errs);
    return !hasErrors;
  };

  const gpHandleAdd = () => {
    if (!gpValidate() || gpSelectedProducts.length === 0) return;
    gpSelectedProducts.forEach((p) => handleAddGeneralProductToOrder(p));
    setGpSelectedProducts([]);
    setGpValidationErrors({});
    setActivePanel("none");
  };



  useEffect(() => {
    if (showGeneralProductsPanel && gpOptionsJob.length === 0 && token) {
      (async () => {
        try {
          const res = await axios.get(`${url.backendURL}job/all`, {
            headers: { Authorization: token },
          });
          const jobs = res.data.response.data || [];
          setGpOptionsJob(
            jobs.map((j) => ({
              value: j.id,
              label: j.name,
              phaseName: j.phase_name,
              systemName: j.system_name,
              siteName: j.site_name || "",
            })),
          );
        } catch (e) {
          console.error("GP fetch jobs error:", e);
        }
      })();
    }
  }, [showGeneralProductsPanel]);

  useEffect(() => {
    if (showGeneralProductsPanel) {
      gpLoadInitial(gpSearchText, gpSortConfig.key, gpSortConfig.direction);
    } else {
      setGpProducts([]);
      setGpSearchText("");
      setGpSelectedProducts([]);
      setGpValidationErrors({});
      setGpSortConfig({ key: "productName", direction: "asc" });
      setGpNextOffset(null);
      setGpOffset(0);
      setGpTotal(0);
    }
  }, [
    showGeneralProductsPanel,
    gpSearchText,
    gpSortConfig.key,
    gpSortConfig.direction,
    vendorId,
  ]);

  useEffect(() => {
    if (bulkJobId) {
      (async () => {
        const data = await fetchJobSystemsPhases(bulkJobId);
        if (data && data.systems) {
          setBulkSystemOptions(data.systems.map(s => ({ value: s.system_id, label: s.system_name })));
        } else {
          setBulkSystemOptions([]);
        }
      })();
    } else {
      setBulkSystemOptions([]);
      setBulkPhaseOptions([]);
    }
  }, [bulkJobId]);

  useEffect(() => {
    if (bulkJobId && bulkSystemId && jobSystemsPhasesMap[bulkJobId]) {
      const sys = jobSystemsPhasesMap[bulkJobId].systems.find(s => s.system_id === bulkSystemId);
      if (sys && sys.phases) {
        setBulkPhaseOptions(sys.phases.map(p => ({ value: p.phase_id, label: p.phase_name })));
      } else {
        setBulkPhaseOptions([]);
      }
    } else {
      setBulkPhaseOptions([]);
    }
  }, [bulkJobId, bulkSystemId, jobSystemsPhasesMap]);

  useEffect(() => {
    if (bulkJobId) {
      setOrderProducts(prev => {
        let changedSomewhere = false;
        const next = prev.map(p => {
          if (p.product_request_id) return p;
          const update = { ...p };
          let changed = false;
          
          if (bulkJobId && !p.job_id) {
            const jobOpt = gpOptionsJob.find(o => o.value === bulkJobId);
            update.job_id = bulkJobId;
            update.job_name = jobOpt?.label || "";
            update.site_name = jobOpt?.siteName || "";
            changed = true;
          }
          
          if (bulkSystemId && !p.system_id && update.job_id === bulkJobId) {
            const sysOpt = bulkSystemOptions.find(o => o.value === bulkSystemId);
            update.system_id = bulkSystemId;
            update.system_name = sysOpt?.label || "";
            changed = true;
          }
          
          if (bulkPhaseId && !p.phase_id && update.system_id === bulkSystemId) {
            const phOpt = bulkPhaseOptions.find(o => o.value === bulkPhaseId);
            update.phase_id = bulkPhaseId;
            update.phase_name = phOpt?.label || "";
            changed = true;
          }
          
          if (changed) {
            update.searchable_text = generateSearchableText(update);
            changedSomewhere = true;
          }
          return changed ? update : p;
        });
        return changedSomewhere ? next : prev;
      });
    }
  }, [orderProducts.length, bulkJobId, bulkSystemId, bulkPhaseId, gpOptionsJob, bulkSystemOptions, bulkPhaseOptions]);

  const handleAddGeneralProductToOrder = (product) => {
    const normalizeId = (id) => {
      if (id === null || id === undefined || id === "") return null;
      const n = Number(id);
      return isNaN(n) ? null : n;
    };
    const jobToUse = product.jobId || bulkJobId;
    const sysToUse = product.systemId || (jobToUse === bulkJobId ? bulkSystemId : null);
    const phToUse = product.phaseId || (sysToUse === bulkSystemId ? bulkPhaseId : null);

    const jobOption = gpOptionsJob.find(
      (j) => Number(j.value) === Number(jobToUse),
    );
    const jobName = jobOption?.label || "";
    const siteName = jobOption?.siteName || "";
    let systemName = "",
      phaseName = "";
    if (jobToUse && jobSystemsPhasesMap[jobToUse]) {
      const jd = jobSystemsPhasesMap[jobToUse];
      if (jd.systems && sysToUse) {
        const sys = jd.systems.find((s) => s.system_id === sysToUse);
        if (sys) {
          systemName = sys.system_name || "";
          if (sys.phases && phToUse) {
            const ph = sys.phases.find((p) => p.phase_id === phToUse);
            if (ph) phaseName = ph.phase_name || "";
          }
        }
      }
    }
    const qty = Number(product.quantity) || 1;
    const rate = Number(product.rate) || 0;
    const newProduct = {
      product_id: product.productId,
      product_request_id: null,
      system_id: sysToUse || null,
      phase_id: phToUse || null,
      job_id: jobToUse || null,
      quantity: qty,
      rate,
      amount: rate * qty,
      description: product.description || "",
      name: product.productName,
      product_name: product.productName,
      productName: product.productName,
      manufacturer_name: product.manufacturerName,
      model: product.model,
      sku: product.sku,
      inventory_type: product.inventoryType,
      warehouse_name:
        warehouseOptions.find((w) => w.value === address.warehouseId)?.label ||
        "",
      phase_name: phaseName || product.phaseNames || "",
      site_name: siteName,
      isSelected: false,
      moved: false,
      isNewlyAdded: true,
    };
    newProduct.searchable_text = product.searchable_text || "";
    newProduct.searchable_text = generateSearchableText(newProduct);
    setOrderPagination((prev) => ({ ...prev, pageIndex: 0 }));
    setOrderProducts((prev) => {
      const existing = prev.findIndex(
        (p) =>
          normalizeId(p.product_id) === normalizeId(newProduct.product_id) &&
          normalizeId(p.job_id) === normalizeId(newProduct.job_id) &&
          normalizeId(p.system_id) === normalizeId(newProduct.system_id) &&
          normalizeId(p.phase_id) === normalizeId(newProduct.phase_id) &&
          !p.product_request_id,
      );
      if (existing !== -1) {
        const updated = [...prev];
        const mergedQty = Number(updated[existing].quantity) + qty;
        const existingRate = Number(updated[existing].rate) || 0;
        updated[existing] = {
          ...updated[existing],
          quantity: mergedQty,
          amount: existingRate * mergedQty,
        };
        return updated;
      }
      return [newProduct, ...prev];
    });
    setGpProducts((prev) => 
      prev.filter((p) => normalizeId(p.productId) !== normalizeId(product.productId))
    );
    setGpTotal((prev) => (prev > 0 ? prev - 1 : 0));
    setHasUnsavedChanges(true);
  };

  const handleError = (err, alertFor) => {
    const { response } = err;
    if (alertRef.current)
      alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    if (
      response?.data?.error === "jwt expired" ||
      response?.data?.error === "Unauthorized. User not found"
    ) {
      localStorage.removeItem("coyote-token");
      navigate(
        `/${decodedToken?.roles?.some((r) => r.role_type === roleTypes.SUPER_ADMIN) ? "admin" : "user"}/auth/sign-in`,
        { state: { status: "expired" } },
      );
    } else {
      setErrors(response?.data?.error || {});
      setAlert({
        message: response ? response?.data?.message : "An error occurred",
        type: "danger",
        show: true,
        alertFor,
      });
      setTimeout(
        () => setAlert({ show: false, alertFor: "", message: "", type: "" }),
        5000,
      );
    }
  };

  const getTodayLocal = () => {
    const n = new Date();
    return new Date(n.getFullYear(), n.getMonth(), n.getDate());
  };
  const todayFormatted = formatDateMMDDYYYY(getTodayLocal());

  const validationSchema = () =>
    Yup.object().shape({
      date: Yup.string().required("Date is required"),
      poNumber: Yup.string()
        .matches(
          /^[A-Za-z0-9-]+$/,
          "PO # can only contain alphanumeric characters and hyphens",
        )
        .min(3, "PO # must be at least 3 characters")
        .required("PO # is required")
        .trim(),
      vendorId: Yup.number()
        .integer()
        .positive()
        .typeError("Vendor is invalid")
        .required("Vendor is required"),
      warehouseId: Yup.number()
        .integer()
        .positive()
        .typeError("Warehouse is invalid")
        .required("Warehouse is required"),
      shipTo: Yup.string()
        .matches(
          /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9!@#$%^&*()_+=[\]{};':"\\|,.<>/?-\s]*$/,
          "Ship To address must contain at least 2 character long",
        )
        .min(2)
        .max(255)
        .trim()
        .required("Ship To address is required"),
    });

  const [optionsVendor, setOptionsVendor] = useState([]);
  const [optionsVendorForPO, setOptionsVendorForPO] = useState([]);

  useEffect(() => {
    setOptionsVendor([
      { value: "all", label: "Select Vendor" },
      ...allVendors.map((v) => ({
        value: v.id,
        label: v.name === "N/A" || !v.name ? "No vendor" : v.name,
      })),
    ]);
  }, [allVendors]);

  useEffect(() => {
    setOptionsVendorForPO(
      allVendors.map((v) => ({
        value: v.id,
        label: v.name === "N/A" || !v.name ? "No vendor" : v.name,
      })),
    );
  }, [allVendors]);

  const validationSchemaItem = () =>
    Yup.object().shape({
      items: Yup.array()
        .of(
          Yup.object().shape({
            productRequestId: Yup.number()
              .integer()
              .nullable()
              .optional()
              .typeError("Product request must be a valid"),
            productId: Yup.number()
              .integer()
              .required("Product is required")
              .typeError("Product must be a valid"),
            jobId: Yup.number()
              .integer()
              .nullable()
              .optional()
              .typeError("Job must be a valid"),
            systemId: Yup.number()
              .integer()
              .nullable()
              .optional()
              .typeError("System must be a valid"),
            phaseId: Yup.number()
              .integer()
              .nullable()
              .optional()
              .typeError("Phase must be a valid"),
            quantity: Yup.number()
              .required("Quantity is required")
              .integer("Quantity must be an integer")
              .typeError("Quantity must be a number")
              .positive("Quantity must be greater than 0"),
            description: Yup.string().max(
              5000,
              "Description must not exceed 5000 characters",
            ),
            rate: Yup.number()
              .required("Rate is required")
              .typeError("Rate must be a number")
              .transform((v) => (v === "" ? null : v))
              .moreThan(0, "Rate must be greater than 0")
              .test(
                "is-decimal",
                "Rate must have a maximum of 2 decimal places",
                (v) => v === null || /^[+-]?\d+(\.\d{1,2})?$/.test(v),
              ),
          }),
        )
        .min(1, "Items are required")
        .required("Items are required"),
    });

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  useEffect(() => {
    setWarehouseOptions(
      warehouses.length > 0
        ? warehouses.map((w) => ({
            value: w.id,
            label: w.name,
            address: w.address,
          }))
        : [],
    );
  }, [warehouses]);

  const [selectedProductsData, setSelectedProductsData] = useState(new Map());

  const handleSelectRowProduct = (row) => {
    const productKey = createProductKey(row.original);
    const isSel = row.original.isSelected;
    setProducts((prev) =>
      prev.map((p) =>
        createProductKey(p) === productKey &&
        p.status !== "in-active" &&
        !p.moved
          ? { ...p, isSelected: !isSel }
          : p,
      ),
    );
    setSelectedProductKeys((prev) => {
      const s = new Set(prev);
      isSel ? s.delete(productKey) : s.add(productKey);
      return s;
    });
    setSelectedProductsData((prev) => {
      const m = new Map(prev);
      isSel ? m.delete(productKey) : m.set(productKey, row.original);
      return m;
    });
  };

  const enhancedOrderProducts = useMemo(() => {
    const filtered = filterOrderProducts(
      orderProducts,
      orderProductsGlobalFilter,
    );
    setTotalOrderRecords(filtered.length);
    return getPaginatedData(
      filtered,
      orderPagination.pageIndex,
      orderPagination.pageSize,
    ).map((p) => ({ ...p }));
  }, [
    orderProducts,
    orderProductsGlobalFilter,
    orderPagination.pageIndex,
    orderPagination.pageSize,
  ]);

  const productColumns = useMemo(
    () => [
      {
        id: "select",
        header: "",
        size: 40,
        Cell: ({ row }) => (
          <Checkbox
            checked={row.original.isSelected || false}
            disabled={row.original.status === "in-active" || row.original.moved}
            onChange={() => handleSelectRowProduct(row)}
          />
        ),
      },
      { accessorKey: "quantity", header: "Quantity", size: 150 },
      { accessorKey: "manufacturer_name", header: "Make", size: 150 },
      { accessorKey: "model", header: "Model", size: 150 },
      { accessorFn: (row) => row.description || "", id: "description", header: "Description", size: 150 },
      { accessorKey: "sku", header: "SKU", size: 150 },
      { accessorKey: "rate", header: "Rate", size: 150 },
      { accessorKey: "amount", header: "Amount", size: 150 },
      { accessorKey: "job_name", header: "Job", size: 150 },
      { accessorKey: "system_name", header: "System", size: 150 },
      { accessorKey: "phase_name", header: "Phase", size: 150 },
      { accessorKey: "warehouse_name", header: "Warehouse", size: 150 },
      { accessorKey: "site_name", header: "Site Name", size: 150 },
    ],
    [],
  );

  const updateProductInOrder = (
    productId,
    value,
    key,
    product,
    productRequestId,
    systemId,
    phaseId,
  ) => {
    setOrderProducts((prev) =>
      prev.map((item) => {
        const itemKey = createProductKey(item);
        const targetKey = createProductKey({
          product_id: productId,
          product_request_id: productRequestId,
          job_id: product.job_id,
          system_id: systemId,
          phase_id: phaseId,
        });
        return itemKey === targetKey ? { ...item, [key]: value } : item;
      }),
    );
  };

  const handleProductRateChange = useCallback(
    (productId, newRate, cell, productRequestId, systemId, phaseId) => {
      updateProductInOrder(
        productId,
        newRate,
        "rate",
        cell.row.original,
        productRequestId,
        systemId,
        phaseId,
      );
    },
    [],
  );

  const productOrderColumns = useMemo(
    () => [
      
      {
        accessorKey: "quantity",
        header: "Quantity",
        size: 120,
        Cell: ({ row, cell }) => {
          const isGeneral = !row.original.product_request_id;
          if (!isGeneral) return <span style={{ fontSize: "0.85rem" }}>{cell.getValue()}</span>;
          
          return (
            <TextField
              type="number"
              size="small"
              value={cell.getValue() ?? ""}
              inputProps={{ min: 1, max: 99999 }}
              onChange={(e) => {
                const val = e.target.value;
                const numVal = parseInt(val, 10);
                if (val === "" || (!isNaN(numVal) && numVal > 0 && numVal <= 99999)) {
                  setOrderProducts((prev) => 
                    prev.map((item) => {
                      if (item.product_id === row.original.product_id && 
                          item.job_id === row.original.job_id &&
                          item.system_id === row.original.system_id &&
                          item.phase_id === row.original.phase_id &&
                          !item.product_request_id) {
                        const updated = { ...item, quantity: val === "" ? "" : numVal, amount: (val === "" ? 0 : numVal) * item.rate };
                        updated.searchable_text = generateSearchableText(updated);
                        return updated;
                      }
                      return item;
                    })
                  );
                }
              }}
              sx={{ width: "80px" }}
            />
          );
        }
      },
      { accessorKey: "manufacturer_name", header: "Make", size: 150 },
      { accessorKey: "model", header: "Model", size: 150 },
      { accessorFn: (row) => row.description || "", id: "description", header: "Description", size: 150 },
      { accessorKey: "sku", header: "SKU", size: 150 },
      {
        accessorKey: "rate",
        header: "Rate",
        size: 150,
        Cell: ({ cell }) => {
          const productId = cell.row.original.product_id;
          const productRequestId = cell.row.original.product_request_id;
          const jobId = cell.row.original.job_id;
          const systemId = cell.row.original.system_id;
          const phaseId = cell.row.original.phase_id;
          const rate = cell.getValue();
          const productKey = createProductKey({
            product_id: productId,
            product_request_id: productRequestId,
            job_id: jobId,
            system_id: systemId,
            phase_id: phaseId,
          });
          const rateError =
            rateErrors[productKey] ||
            (validationErrors &&
              typeof validationErrors === "object" &&
              validationErrors[productKey]?.rate);
          if (productRequestId) return <span style={{ fontSize: "0.85rem" }}>{rate}</span>;

          return (
            <>
              <TextField
                type="text"
                min={0}
                inputMode="decimal"
                value={rate}
                variant="outlined"
                size="small"
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*(\.\d{0,2})?$/.test(value) || value === "") {
                    handleProductRateChange(
                      productId,
                      value === "" ? "" : value,
                      cell,
                      productRequestId,
                      systemId,
                      phaseId,
                    );
                    const numVal = parseFloat(value);
                    if (value === "" || isNaN(numVal) || numVal <= 0) {
                      setRateErrors((prev) => ({
                        ...prev,
                        [productKey]: "Rate must be greater than 0",
                      }));
                    } else {
                      setRateErrors((prev) => {
                        const u = { ...prev };
                        delete u[productKey];
                        return u;
                      });
                      setValidationErrors((prev) => {
                        if (!prev || typeof prev !== "object") return prev;
                        const u = { ...prev };
                        if (u[productKey]) {
                          const { rate: _r, ...rest } = u[productKey];
                          if (Object.keys(rest).length === 0)
                            delete u[productKey];
                          else u[productKey] = rest;
                        }
                        return u;
                      });
                    }
                  }
                }}
                onBlur={(e) => {
                  if (e.target.value)
                    handleProductRateChange(
                      productId,
                      String(parseFloat(e.target.value)),
                      cell,
                      productRequestId,
                      systemId,
                      phaseId,
                    );
                }}
              />
              {rateError && (
                <div className="small text-danger mt-1">{rateError}</div>
              )}
            </>
          );
        },
      },
      { accessorKey: "amount", header: "Amount", size: 150 },
      {
        accessorKey: "searchable_text",
        header: "Searchable Text",
        size: 0,
        enableHiding: true,
        enableColumnFilter: true,
        enableGlobalFilter: true,
        muiTableHeadCellProps: { sx: { display: "none" } },
        muiTableBodyCellProps: { sx: { display: "none" } },
      },
      {
        accessorKey: "job_name",
        header: "Job",
        size: 180,
        Cell: ({ row }) => {
          const isGeneral = !row.original.product_request_id;
          if (!isGeneral) return <span style={{ fontSize: "0.85rem" }}>{row.original.job_name || ""}</span>;

          const p = row.original;
          const k = createProductKey(p);
          const err = validationErrors?.[k]?.jobId;
          return (
            <>
              <Select
                options={gpOptionsJob}
                value={gpOptionsJob.find((o) => o.value === p.job_id) || null}
                onChange={async (opt) => {
                  const newJobId = opt?.value || null;
                  const newJobName = opt?.label || "";
                  const newSiteName = opt?.siteName || "";
                  setOrderProducts((prev) => prev.map((item) => {
                    if (item.product_id === p.product_id && 
                        item.job_id === p.job_id &&
                        item.system_id === p.system_id &&
                        item.phase_id === p.phase_id &&
                        !item.product_request_id) {
                       const updated = { ...item, job_id: newJobId, job_name: newJobName, site_name: newSiteName, system_id: null, system_name: "", phase_id: null, phase_name: "" };
                       updated.searchable_text = generateSearchableText(updated);
                       return updated;
                    }
                    return item;
                  }));
                  if (newJobId) {
                    const jd = await fetchJobSystemsPhases(newJobId);
                    if (jd?.active_system_id && jd?.active_phase_id) {
                       setOrderProducts((prev) => prev.map((item) => {
                         if (item.product_id === p.product_id && item.job_id === newJobId && !item.system_id && !item.product_request_id) {
                           let sName = "", pName = "";
                           if (jobSystemsPhasesMap[newJobId]) {
                             const sys = jobSystemsPhasesMap[newJobId].systems.find(s => s.system_id === jd.active_system_id);
                             if (sys) {
                               sName = sys.system_name;
                               const ph = sys.phases.find(phx => phx.phase_id === jd.active_phase_id);
                               if (ph) pName = ph.phase_name;
                             }
                           }
                           const updated = { ...item, system_id: jd.active_system_id, system_name: sName, phase_id: jd.active_phase_id, phase_name: pName };
                           updated.searchable_text = generateSearchableText(updated);
                           return updated;
                         }
                         return item;
                       }));
                    }
                  }
                }}
                isClearable
                placeholder="Select Job"
                menuPortalTarget={document.body}
                menuPosition="fixed"
                menuPlacement="auto"
                styles={{
                  container: (b) => ({
                    ...b,
                    width: "170px",
                    border: err ? "1px solid red" : b.border,
                  }),
                  option: (b, s) => ({
                    ...b,
                    backgroundColor: s.isSelected ? "#007bff" : s.isFocused ? "#e6f7ff" : "#fff",
                    color: "#333",
                    fontSize: "0.8rem",
                  }),
                  menuPortal: (b) => ({ ...b, zIndex: 9999 }),
                  menu: (b) => ({ ...b, zIndex: 9999 }),
                }}
              />
              {err && <div className="small text-danger mt-1">{err}</div>}
            </>
          );
        }
      },
      {
        accessorKey: "system_name",
        header: "System",
        size: 190,
        Cell: ({ row }) => {
          const isGeneral = !row.original.product_request_id;
          if (!isGeneral) return <span style={{ fontSize: "0.85rem" }}>{row.original.system_name || ""}</span>;

          const p = row.original;
          const sysOpts =
            p.job_id && jobSystemsPhasesMap[p.job_id]
              ? jobSystemsPhasesMap[p.job_id].systems.map((s) => ({
                  value: s.system_id,
                  label: s.system_name,
                }))
              : [];
          const k = createProductKey(p);
          const err = validationErrors?.[k]?.systemId;
          return (
            <>
              <Select
                options={sysOpts}
                value={sysOpts.find((o) => o.value === p.system_id) || null}
                isDisabled={!p.job_id}
                onChange={(opt) => {
                  const newSysId = opt?.value || null;
                  const newSysName = opt?.label || "";
                  setOrderProducts((prev) => prev.map((item) => {
                    if (item.product_id === p.product_id && 
                        item.job_id === p.job_id &&
                        item.system_id === p.system_id &&
                        item.phase_id === p.phase_id &&
                        !item.product_request_id) {
                       const updated = { ...item, system_id: newSysId, system_name: newSysName, phase_id: null, phase_name: "" };
                       updated.searchable_text = generateSearchableText(updated);
                       return updated;
                    }
                    return item;
                  }));
                }}
                isClearable
                placeholder={!p.job_id ? "Select job first" : "Select System"}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                menuPlacement="auto"
                styles={{
                  container: (b) => ({
                    ...b,
                    width: "180px",
                    border: err ? "1px solid red" : b.border,
                  }),
                  option: (b, s) => ({
                    ...b,
                    backgroundColor: s.isSelected ? "#007bff" : s.isFocused ? "#e6f7ff" : "#fff",
                    color: "#333",
                    fontSize: "0.8rem",
                  }),
                  menuPortal: (b) => ({ ...b, zIndex: 9999 }),
                  menu: (b) => ({ ...b, zIndex: 9999 }),
                  placeholder: (b) => ({
                    ...b,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }),
                }}
              />
              {err && <div className="small text-danger mt-1">{err}</div>}
            </>
          );
        }
      },
      {
        accessorKey: "phase_name",
        header: "Phase",
        size: 190,
        Cell: ({ row }) => {
          const isGeneral = !row.original.product_request_id;
          if (!isGeneral) return <span style={{ fontSize: "0.85rem" }}>{row.original.phase_name || ""}</span>;

          const p = row.original;
          const phaseOpts =
            p.job_id && p.system_id && jobSystemsPhasesMap[p.job_id]
              ? (
                  jobSystemsPhasesMap[p.job_id].systems.find(
                    (s) => s.system_id === p.system_id,
                  )?.phases || []
                ).map((ph) => ({ value: ph.phase_id, label: ph.phase_name }))
              : [];
          const k = createProductKey(p);
          const err = validationErrors?.[k]?.phaseId;
          return (
            <>
              <Select
                options={phaseOpts}
                value={phaseOpts.find((o) => o.value === p.phase_id) || null}
                isDisabled={!p.system_id}
                onChange={(opt) => {
                  const newPhaseId = opt?.value || null;
                  const newPhaseName = opt?.label || "";
                  setOrderProducts((prev) => prev.map((item) => {
                    if (item.product_id === p.product_id && 
                        item.job_id === p.job_id &&
                        item.system_id === p.system_id &&
                        item.phase_id === p.phase_id &&
                        !item.product_request_id) {
                       const updated = { ...item, phase_id: newPhaseId, phase_name: newPhaseName };
                       updated.searchable_text = generateSearchableText(updated);
                       return updated;
                    }
                    return item;
                  }));
                }}
                isClearable
                placeholder={!p.system_id ? "Select system first" : "Select Phase"}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                menuPlacement="auto"
                styles={{
                  container: (b) => ({
                    ...b,
                    width: "180px",
                    border: err ? "1px solid red" : b.border,
                  }),
                  option: (b, s) => ({
                    ...b,
                    backgroundColor: s.isSelected ? "#007bff" : s.isFocused ? "#e6f7ff" : "#fff",
                    color: "#333",
                    fontSize: "0.8rem",
                  }),
                  menuPortal: (b) => ({ ...b, zIndex: 9999 }),
                  menu: (b) => ({ ...b, zIndex: 9999 }),
                  placeholder: (b) => ({
                    ...b,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }),
                }}
              />
              {err && <div className="small text-danger mt-1">{err}</div>}
            </>
          );
        }
      },
      {
        id: "requested_product",
        header: "Requested Product",
        size: 100,
        Cell: ({ row }) => (
          <span style={{ fontSize: "0.85rem" }}>
            {row.original.product_request_id ? "Yes" : "No"}
          </span>
        ),
      },
      { accessorKey: "warehouse_name", header: "Warehouse", size: 150 },
      { accessorKey: "site_name", header: "Site Name", size: 150 },
      {
        accessorKey: "action",
        header: "Action",
        size: 150,
        Cell: ({ row }) => {
          const handleDelete = () => {
            const isGeneral = !row.original.product_request_id;
            const key = createProductKey(row.original);
            setOrderProducts((prev) => {
              const newList = prev.filter((item) => createProductKey(item) !== key);
              if (isGeneral && showGeneralProductsPanel) {
                gpLoadInitial(
                  gpSearchText,
                  gpSortConfig.key,
                  gpSortConfig.direction,
                  newList,
                );
              }
              return newList;
            });
          };
          return (
            <>
              <Link
                className="btn btn-sm btn-icon btn-success"
                onClick={(e) => {
                  e.preventDefault();
                  handleProductView(e, row.original);
                }}
                title="View"
              >
                <span className="btn-inner">
                  <IoEyeOutline style={{ width: "20px", height: "20px" }} />
                </span>
              </Link>
              <Link>
                <Tooltip title="Remove">
                  <IconButton
                    size="medium"
                    color="error"
                    onClick={handleDelete}
                  >
                    <CancelIcon fontSize="medium" />
                  </IconButton>
                </Tooltip>
              </Link>
            </>
          );
        },
      },
    ],
    [validationErrors, rateErrors, gpOptionsJob, jobSystemsPhasesMap],
  );
  const [draggingRowProduct, setDraggingRowProduct] = useState(null);
  const [hoveredTableProduct, setHoveredTableProduct] = useState(null);
  const [rowHoverPopoverOpen, setRowHoverPopoverOpen] = useState(false);
  const [rowHoverPopoverAnchor, setRowHoverPopoverAnchor] = useState(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [hoveredRowId, setHoveredRowId] = useState(null);
  const hoverTimeoutRef = useRef(null);
  const generalProductColumns = useMemo(
    () => [
      {
        id: "gpSelect",
        size: 50,
        enableSorting: false,
        Header: ({ table }) => {
          const allSel =
            gpProducts.length > 0 &&
            gpProducts.every((p) =>
              gpIsInSelection(p.productId, p.systemId, p.phaseId),
            );
          return (
            <Checkbox
              checked={allSel && !gpLoadingInitial}
              disabled={gpLoadingInitial}
              onChange={(e) => {
                if (e.target.checked) {
                  const newOnes = gpProducts.filter(
                    (p) => !gpIsInSelection(p.productId, p.systemId, p.phaseId),
                  );
                  setGpSelectedProducts((prev) => [
                    ...prev,
                    ...newOnes.map((p) => {
                      const item = {
                        ...p,
                        quantity: p.quantity || 1,
                        rate: p.rate || 0,
                        amount: (p.rate || 0) * (p.quantity || 1),
                      };
                      item.searchable_text = generateSearchableText(item);
                      return item;
                    }),
                  ]);
                } else {
                  const keys = gpProducts.map((p) =>
                    gpCreateKey(p.productId, p.systemId, p.phaseId),
                  );
                  setGpSelectedProducts((prev) =>
                    prev.filter(
                      (p) =>
                        !keys.includes(
                          gpCreateKey(p.productId, p.systemId, p.phaseId),
                        ),
                    ),
                  );
                }
              }}
            />
          );
        },
        Cell: ({ row }) => {
          const p = row.original;
          if (p.isLoadMoreRow) {
            return (
              <div
                style={{
                  position: "sticky",
                  left: "0",
                  right: "0",
                  width: "fit-content",
                  margin: "0 auto",
                  display: "flex",
                  justifyContent: "center",
                  pointerEvents: "none",
                  zIndex: 10,
                  backgroundColor: "white",
                }}
              >
                <div style={{ pointerEvents: "auto", padding: "15px 0" }}>
                  <button
                    type="button"
                    className="btn btn-outline-primary px-4 py-2"
                    onClick={() => gpLoadMore()}
                    disabled={gpLoadingMore}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#3a57e8";
                      e.currentTarget.style.color = "#fff";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "white";
                      e.currentTarget.style.color = "#3a57e8";
                    }}
                    style={{
                      borderRadius: "20px",
                      fontWeight: "400",
                      fontSize: "14px",
                      minWidth: "160px",
                    }}
                  >
                    {gpLoadingMore ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" />
                        Loading...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-plus-circle me-2" />
                        Load More
                      </>
                    )}
                  </button>
                </div>
              </div>
            );
          }
          const isSel = gpIsInSelection(p.productId, p.systemId, p.phaseId);
          const k = gpCreateKey(p.productId, p.systemId, p.phaseId);
          const hasErr = Object.keys(gpValidationErrors[k] || {}).length > 0;
          return (
            <Checkbox
              checked={isSel}
              disabled={gpLoadingInitial}
              sx={hasErr && isSel ? { color: "red" } : {}}
              onChange={() => gpSelectRow(p, false)}
            />
          );
        },
      },
      {
        accessorKey: "quantity",
        header: "Qty",
        size: 100,
        Cell: ({ row }) => {
          if (row.original.isLoadMoreRow) return null;
          return <span style={{ fontSize: "0.85rem" }}>{row.original.quantity || 1}</span>;
        },
      },
      {
        accessorKey: "manufacturerName",
        header: "Make",
        size: 140,
        Cell: ({ row }) => {
          if (row.original.isLoadMoreRow) return null;
          return (
            <span style={{ fontSize: "0.85rem" }}>
              {row.original.manufacturerName || ""}
            </span>
          );
        },
      },
      {
        accessorKey: "model",
        header: "Model",
        size: 130,
        Cell: ({ row }) => {
          if (row.original.isLoadMoreRow) return null;
          return (
            <span style={{ fontSize: "0.85rem" }}>
              {row.original.model || ""}
            </span>
          );
        },
      },
      {
        accessorKey: "description",
        header: "Description",
        size: 180,
        Cell: ({ row }) => {
          const p = row.original;
          if (p.isLoadMoreRow) return null;
          const isSel = gpIsInSelection(p.productId, p.systemId, p.phaseId);
          if (isSel)
            return (
              <TextField
                size="small"
                value={p.description || ""}
                InputProps={{ readOnly: true }}
                sx={{
                  width: "160px",
                  "& .MuiInputBase-input": {
                    cursor: "not-allowed",
                    fontSize: "0.8rem",
                  },
                }}
              />
            );
          return (
            <span style={{ fontSize: "0.85rem" }}>{p.description || ""}</span>
          );
        },
      },
      {
        accessorKey: "sku",
        header: "SKU",
        size: 130,
        Cell: ({ row }) => {
          if (row.original.isLoadMoreRow) return null;
          return (
            <span style={{ fontSize: "0.85rem" }}>
              {row.original.sku || ""}
            </span>
          );
        },
      },
      {
        accessorKey: "rate",
        header: "Rate",
        size: 130,
        Cell: ({ row }) => {
          if (row.original.isLoadMoreRow) return null;
          return <span style={{ fontSize: "0.85rem" }}>{row.original.rate || 0}</span>;
        },
      },
      {
        accessorKey: "amount",
        header: "Amount",
        size: 110,
        Cell: ({ row }) => {
          if (row.original.isLoadMoreRow) return null;
          return (
            <span style={{ fontSize: "0.85rem" }}>
              {row.original.amount ?? 0}
            </span>
          );
        },
      },

      {
        id: "gpAction",
        header: "Action",
        size: 70,
        Cell: ({ row }) => {
          if (row.original.isLoadMoreRow) return null;
          return (
            <Link
              className="btn btn-sm btn-icon btn-success"
              onClick={(e) => {
                e.preventDefault();
                setGpViewItem(row.original);
                setGpViewModal(true);
              }}
              title="View"
            >
              <span className="btn-inner">
                <IoEyeOutline style={{ width: "20px", height: "20px" }} />
              </span>
            </Link>
          );
        },
      },
    ],
    [
      gpProducts,
      gpSelectedProducts,
      gpValidationErrors,
      gpOptionsJob,
      gpLoadingInitial,
      gpLoadingMore,
      gpLoadMore,
      gpNextOffset,
      gpTotal,
      jobSystemsPhasesMap,
    ],
  );

  const gpTableData = useMemo(() => {
    if (!gpLoadingInitial && gpNextOffset !== null && gpNextOffset < gpTotal) {
      return [
        ...gpProducts,
        { id: "GP_LOAD_MORE_FAKE_ID", isLoadMoreRow: true },
      ];
    }
    return gpProducts;
  }, [gpProducts, gpLoadingInitial, gpNextOffset, gpTotal]);

  const tableGeneralProduct = useMaterialReactTable({
    columns: generalProductColumns,
    data: gpTableData,
    enableColumnFilters: false,
    enableFullScreenToggle: false,
    enableFilterMatchHighlighting: false,
    enableRowDragging: true,
    onDraggingRowChange: setDraggingRowProduct,
    getRowId: (row) => gpCreateKey(row.productId, row.systemId, row.phaseId),
    muiRowDragHandleProps: ({ row }) => ({
      title: "Drag to move",
      onDragStart: () => {
        setRowHoverPopoverOpen(false);
        setRowHoverPopoverAnchor(null);
        setHoveredRowId(null);
        if (hoverTimeoutRef.current) {
          clearTimeout(hoverTimeoutRef.current);
          hoverTimeoutRef.current = null;
        }
      },
      onDragEnd: async () => {
        setDragPopoverOpen(false);
        setDragPopoverAnchor(null);
        if (hoveredTableProduct === "order-product") {
          const p = draggingRowProduct.original;
          if (!p.isLoadMoreRow) {
            const isSel = gpIsInSelection(p.productId, p.systemId, p.phaseId);
            if (isSel) {
              gpSelectedProducts.forEach((prod) => handleAddGeneralProductToOrder(prod));
              setGpSelectedProducts([]);
              setGpValidationErrors({});
            } else {
              handleAddGeneralProductToOrder({
                ...p,
                quantity: p.quantity || 1,
                rate: p.rate || 0,
              });
            }
            await animatedMoveProduct(p);
            setGpProducts((prev) => prev.filter((item) => item.productId !== p.productId));
            setGpTotal((prev) => (prev > 0 ? prev - 1 : 0));
            setOrderPagination((prev) => ({ ...prev, pageIndex: 0 }));
          }
        }
        setHoveredTableProduct(null);
      },
      onMouseEnter: (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!row.original.isLoadMoreRow) {
          setDragPopoverAnchor(e.currentTarget);
          setDragPopoverOpen(true);
        }
      },
      onMouseLeave: (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragPopoverOpen(false);
        setDragPopoverAnchor(null);
      },
      sx: { cursor: row.original.isLoadMoreRow ? "default" : "grab" },
    }),
    enableRowSelection: false,
    enablePagination: false,
    enableBottomToolbar: false,
    muiTableBodyCellProps: ({ cell, row }) => {
      if (row.original.isLoadMoreRow) {
        if (cell.column.id === "gpSelect") {
          return {
            colSpan: 15,
            sx: {
              display: "block",
              position: "sticky",
              width: "100%",
              left: "45%",
              bottom: 0,
              padding: "0",
              borderBottom: "none",
              zIndex: 10,
              backgroundColor: "white",
              height: "70px",
              boxShadow: "0px -4px 10px rgba(0,0,0,0.05)",
            },
          };
        }
        return {
          sx: { display: "none" },
        };
      }
      return {};
    },
    muiTableBodyRowProps: ({ row }) => {
      const p = row.original;
      if (p.isLoadMoreRow) return { sx: { cursor: "default" } };
      const isSel = gpIsInSelection(p.productId, p.systemId, p.phaseId);
      const key = gpCreateKey(p.productId, p.systemId, p.phaseId);
      const k = key;
      const hasErr =
        isSel && Object.keys(gpValidationErrors[k] || {}).length > 0;

      return {
        onMouseEnter: (e) => {
          if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
          }
          setHoveredRowId(key);
          hoverTimeoutRef.current = setTimeout(() => {
            setRowHoverPopoverAnchor(e.currentTarget);
            setMousePosition({ x: e.clientX, y: e.clientY });
            setRowHoverPopoverOpen(true);
          }, 50);
        },
        onMouseMove: (e) => {
          if (rowHoverPopoverOpen && hoveredRowId === key)
            setMousePosition({ x: e.clientX, y: e.clientY });
        },
        onMouseLeave: () => {
          if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
          }
          if (hoveredRowId === key) {
            hoverTimeoutRef.current = setTimeout(() => {
              setRowHoverPopoverOpen(false);
              setRowHoverPopoverAnchor(null);
              setHoveredRowId(null);
            }, 100);
          }
        },
        onClick: async (e) => {
          if (
            ["INPUT", "BUTTON", "A", "TEXTAREA", "SELECT"].includes(
              e.target.tagName,
            ) ||
            e.target.closest(".MuiCheckbox-root") ||
            e.target.closest(".MuiSelect-root") ||
            e.target.closest(".MuiTableDragHandle-root") ||
            e.target.closest("svg") ||
            e.target.closest(".react-select__control")
          )
            return;
          
          if (isSel) {
            gpSelectedProducts.forEach((prod) => handleAddGeneralProductToOrder(prod));
            setGpSelectedProducts([]);
            setGpValidationErrors({});
          } else {
            handleAddGeneralProductToOrder({
              ...p,
              quantity: p.quantity || 1,
              rate: p.rate || 0,
            });
          }
          await animatedMoveProduct(p);
          setOrderPagination((prev) => ({ ...prev, pageIndex: 0 }));
        },
        sx: {
          backgroundColor: isSel ? "#ecf2f9c2" : "inherit",
          outline: hasErr ? "2px solid red" : "none",
          cursor: "pointer",
          "&:hover": {
            backgroundColor: isSel ? "#ddeeff" : "rgba(33,108,220,0.05)",
          },
        },
      };
    },
    enableGlobalFilter: true,
    manualFiltering: true,
    onGlobalFilterChange: setGpSearchText,
    enableTopToolbar: true,
    muiTopToolbarProps: { className: "compact-pagination-topbar" },
    state: {
      draggingRow: draggingRowProduct,
      isLoading: gpLoadingInitial,
      globalFilter: gpSearchText,
    },
    muiTableContainerProps: { sx: { minHeight: "60vh", maxHeight: "60vh" } },
    muiTablePaperProps: {
      sx: { width: "100%", minWidth: "100%", overflow: "visible" },
    },
  });



  const getAllSelectedProducts = () =>
    Array.from(selectedProductsData.values());

  const animatedMoveProduct = async (product) => {
    const key = createProductKey(product);
    setAnimatingRows((prev) => new Set([...prev, key]));
    setMovingProducts((prev) => new Set([...prev, key]));
    await new Promise((resolve) => setTimeout(resolve, 500));
    setTimeout(() => {
      setAnimatingRows((prev) => {
        const s = new Set(prev);
        s.delete(key);
        return s;
      });
      setMovingProducts((prev) => {
        const s = new Set(prev);
        s.delete(key);
        return s;
      });
    }, 400);
  };

  const commonTableProps = {
    autoResetPageIndex: false,
    enableRowDragging: true,
    enableColumnFilter: false,
    enableFullScreenToggle: false,
    enableFilterMatchHighlighting: false,
    muiTableContainerProps: { sx: { minHeight: "60vh", maxHeight: "60vh" } },
    onDraggingRowChange: setDraggingRowProduct,
    state: {
      draggingRow: draggingRowProduct,
      isLoading: loadingProducts,
      pagination,
      globalFilter,
    },
    manualPagination: true,
    manualFiltering: true,
    onPaginationChange: setPagination,
    onGlobalFilterChange: (val) => {
      setGlobalFilter(val);
      setPagination((prev) => ({ ...prev, pageIndex: 0 }));
    },
    rowCount: totalRecords,
  };

  const tableProduct = useMaterialReactTable({
    ...commonTableProps,
    columns: productColumns,
    data: products,
    defaultColumn: { size: 100 },
    enableColumnFilters: false,
    getRowId: (row) => createProductKey(row),
    muiRowDragHandleProps: ({ row }) => ({
      title: "Drag to move",
      onDragStart: () => {
        setRowHoverPopoverOpen(false);
        setRowHoverPopoverAnchor(null);
        setHoveredRowId(null);
        if (hoverTimeoutRef.current) {
          clearTimeout(hoverTimeoutRef.current);
          hoverTimeoutRef.current = null;
        }
      },
      onDragEnd: async () => {
        setDragPopoverOpen(false);
        setDragPopoverAnchor(null);
        if (hoveredTableProduct === "order-product") {
          const draggedKey = createProductKey(draggingRowProduct.original);
          const isDraggedSel = selectedProductKeys.has(draggedKey);
          if (isDraggedSel) {
            const toMove = getAllSelectedProducts();
            if (toMove?.length > 0) {
              toMove.forEach((p) =>
                setOrderProducts((prev) => [
                  { ...p, isSelected: false },
                  ...(Array.isArray(prev) ? prev : []),
                ]),
              );
              setProducts((prev) =>
                prev.map((p) => {
                  const k = createProductKey(p);
                  return selectedProductKeys.has(k)
                    ? { ...p, moved: true, isSelected: false }
                    : p;
                }),
              );
              setSelectedProductKeys(new Set());
              setSelectedProductsData(new Map());
              await Promise.all(toMove.map((d) => animatedMoveProduct(d)));
            }
          } else {
            setOrderProducts((prev = []) => [
              { ...draggingRowProduct.original, isSelected: false },
              ...(Array.isArray(prev) ? prev : []),
            ]);
            setProducts((prev) =>
              prev.map((p) =>
                createProductKey(p) === draggedKey ? { ...p, moved: true } : p,
              ),
            );
            await animatedMoveProduct(draggingRowProduct.original);
          }
        }
        setHoveredTableProduct(null);
      },
      onMouseEnter: (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!row.original.status !== "in-active" && !row.original.moved) return;
        if (row.original.status !== "in-active" && !row.original.moved) {
          setDragPopoverAnchor(e.currentTarget);
          setDragPopoverOpen(true);
        }
      },
      onMouseLeave: (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragPopoverOpen(false);
        setDragPopoverAnchor(null);
      },
      sx: {
        cursor:
          row.original.status === "in-active" || row.original.moved
            ? "not-allowed"
            : "grab",
        opacity:
          row.original.status === "in-active" || row.original.moved ? 0.3 : 1,
        transition: "all 0.2s ease",
      },
    }),
    muiTablePaperProps: {
      onDragEnter: () => setHoveredTableProduct("product"),
      sx: {
        outline:
          hoveredTableProduct === "product" ? "2px dashed #216CDC" : undefined,
        width: "100%",
        minWidth: "100%",
        minHeight: "100px",
        overflow: "visible",
        position: "relative",
        zIndex: 0,
      },
    },
    muiTableBodyRowProps: ({ row }) => {
      const key = createProductKey(row.original);
      const canMove =
        !row.original.status?.includes("in-active") && !row.original.moved;
      return {
        onMouseEnter: (e) => {
          if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
          }
          if (!canMove) {
            setRowHoverPopoverOpen(false);
            setRowHoverPopoverAnchor(null);
            setHoveredRowId(null);
            return;
          }
          setHoveredRowId(key);
          hoverTimeoutRef.current = setTimeout(() => {
            setRowHoverPopoverAnchor(e.currentTarget);
            setMousePosition({ x: e.clientX, y: e.clientY });
            setRowHoverPopoverOpen(true);
          }, 50);
        },
        onMouseMove: (e) => {
          if (canMove && rowHoverPopoverOpen && hoveredRowId === key)
            setMousePosition({ x: e.clientX, y: e.clientY });
        },
        onMouseLeave: () => {
          if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
          }
          if (hoveredRowId === key) {
            hoverTimeoutRef.current = setTimeout(() => {
              setRowHoverPopoverOpen(false);
              setRowHoverPopoverAnchor(null);
              setHoveredRowId(null);
            }, 100);
          }
        },
        onClick: async (e) => {
          if (
            e.target.closest("input[type='checkbox']") ||
            e.target.closest(".MuiTableDragHandle-root") ||
            e.target.closest("svg")
          )
            return;
          if (row.original.status !== "in-active" && !row.original.moved) {
            const clickedKey = createProductKey(row.original);
            if (selectedProductKeys.has(clickedKey)) {
              const toMove = getAllSelectedProducts();
              if (toMove?.length > 0) {
                toMove.forEach((p) =>
                  setOrderProducts((prev) => [
                    { ...p, isSelected: false },
                    ...(Array.isArray(prev) ? prev : []),
                  ]),
                );
                setProducts((prev) =>
                  prev.map((p) => {
                    const k = createProductKey(p);
                    return selectedProductKeys.has(k)
                      ? { ...p, moved: true, isSelected: false }
                      : p;
                  }),
                );
                setSelectedProductKeys(new Set());
                setSelectedProductsData(new Map());
              }
            } else {
              setOrderProducts((prev) => [
                { ...row.original, isSelected: false },
                ...(Array.isArray(prev) ? prev : []),
              ]);
              setProducts((prev) =>
                prev.map((p) =>
                  createProductKey(p) === clickedKey
                    ? { ...p, moved: true }
                    : p,
                ),
              );
            }
            await animatedMoveProduct(row.original);
            setOrderPagination((prev) => ({ ...prev, pageIndex: 0 }));
          }
        },
        sx: {
          backgroundColor:
            row.original.status === "in-active"
              ? "#bcb8b8"
              : row.original.moved
                ? "#216CDC"
                : "inherit",
          pointerEvents: row.original.status === "in-active" ? "none" : "auto",
          cursor: row.original.status === "in-active" ? "no-drop" : "pointer",
          "&:hover": {
            backgroundColor:
              row.original.status !== "in-active" && !row.original.moved
                ? "rgba(33,109,220,0.1)"
                : undefined,
          },
        },
      };
    },
    muiBottomToolbarProps: { className: "compact-pagination-toolbar" },
    muiTopToolbarProps: { className: "compact-pagination-topbar" },
  });

  useEffect(() => {
    setTotalOrderRecords(orderProducts.length);
  }, [orderProducts]);

  const tableOrderProduct = useMaterialReactTable({
    columns: productOrderColumns,
    muiTableContainerProps: { sx: { minHeight: "60vh", maxHeight: "60vh" } },
    data: enhancedOrderProducts,
    enableRowDragging: true,
    enableColumnFilters: false,
    enableFullScreenToggle: false,
    enableFilterMatchHighlighting: false,
    onDraggingRowChange: (row) => setDraggingRowProduct(row),
    getRowId: (row) => `order-${createProductKey(row)}`,
    state: {
      draggingRow: draggingRowProduct,
      pagination: orderPagination,
      globalFilter: orderProductsGlobalFilter,
    },
    manualPagination: true,
    manualFiltering: false,
    onPaginationChange: setOrderPagination,
    onGlobalFilterChange: (val) => {
      setOrderProductsGlobalFilter(val);
      setOrderPagination((prev) => ({ ...prev, pageIndex: 0 }));
    },
    rowCount: totalOrderRecords,
    globalFilterFn: (row, columnId, filterValue) => {
      if (!filterValue || filterValue.trim() === "") return true;
      const searchWords = filterValue.toLowerCase().replace(/[-+]/g, " ").replace(/\s+/g, " ").trim().split(/\s+/);
      const searchableText = (row.original.searchable_text || "").toLowerCase();
      const backupText = [row.original.name, row.original.productName, row.original.manufacturerName].filter(Boolean).join(" ").toLowerCase();
      return searchWords.every((word) => searchableText.includes(word) || backupText.includes(word));
    },
    muiRowDragHandleProps: {
      onDragEnd: () => {
        if (hoveredTableProduct === "product") {
          const p = draggingRowProduct.original;
          const isGeneral = !p.product_request_id;
          const key = createProductKey(p);
          setOrderProducts((prev) => {
            const newList = prev.filter((item) => createProductKey(item) !== key);
            if (isGeneral && showGeneralProductsPanel) {
              gpLoadInitial(
                gpSearchText,
                gpSortConfig.key,
                gpSortConfig.direction,
                newList,
              );
            }
            return newList;
          });
        }
        setHoveredTableProduct(null);
      },
    },
    muiTableBodyRowProps: ({ row }) => {
      const key = createProductKey(row.original);
      const isNew = movingProducts.has(key);
      return {
        sx: {
          ...(isNew && {
            backgroundColor: "#216ddc1a",
            animation:
              "slideInFromLeft 0.6s ease-out forwards, fadeBg 2s ease-out forwards",
            "@keyframes slideInFromLeft": {
              "0%": { transform: "translateX(-100%)", opacity: 0 },
              "100%": { transform: "translateX(0)", opacity: 1 },
            },
            "@keyframes fadeBg": {
              "0%": { backgroundColor: "#216ddc1a" },
              "100%": { backgroundColor: "transparent" },
            },
          }),
        },
      };
    },
    muiTablePaperProps: {
      onDragEnter: () => setHoveredTableProduct("order-product"),
      sx: {
        outline:
          hoveredTableProduct === "order-product"
            ? "2px dashed #216CDC"
            : undefined,
        position: "relative",
        overflow: "visible",
      },
    },
    renderEmptyRowsFallback: () => {
      const isSearchActive = orderProductsGlobalFilter && orderProductsGlobalFilter.trim() !== "";
      return (
        <div
          style={{
            position: "sticky",
            bottom: "0",
            left: "30%",
            width: "100%",
            display: "flex",
            backgroundColor: "white",
            padding: "3rem 0",
            zIndex: 10,
          }}
          className={`${!isTable3Open ? "align-items-center justify-content-center" : "align-items-start justify-content-start ps-5"}`}
        >
          <div className={`text-muted ${!isTable3Open && "ps-5"}`}>
            <i className={`fas ${isSearchActive ? "fa-search-minus" : "fa-search"} fa-3x mb-3 opacity-50`} />
            <div style={{ fontSize: "1.1rem", fontWeight: 500 }}>
              {isSearchActive ? (
                <>No products match your search </>
              ) : (
                <>
                  No products have been added yet.&nbsp;
                  {!isRightPanelOpen && (
                    <>
                      <a
                        style={{ color: "#007bff", cursor: "pointer" }}
                        onClick={() => setActivePanel("requested")}
                      >
                        Add some products
                      </a>
                      &nbsp;to continue.
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      );
    },
    muiBottomToolbarProps: { className: "compact-pagination-toolbar" },
    muiTopToolbarProps: { className: "compact-pagination-topbar" },
  });

  const [itemView, setItemView] = useState();
  const [itemViewModel, setItemViewModel] = useState(false);
  const handleProductView = async (e, item) => {
    e.preventDefault();
    setItemView(item);
    setItemViewModel(true);
  };
  const handleCloseView = () => setItemViewModel(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 769);
  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 769);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);

  const [showTooltip, setShowTooltip] = useState(false);
  const popupRef = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      setShowTooltip(true);
      const t = setTimeout(() => setShowTooltip(false), 2000);
      return () => clearTimeout(t);
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  const buttonContainerStyle = {
    position: "relative",
    cursor: "pointer",
    display: "inline-block",
  };
  const buttonStyle = {
    position: "relative",
    overflow: "hidden",
    borderRadius: "0.75rem",
    backgroundColor: "white",
    padding: "1rem 1.5rem",
    border: "none",
    outline: "none",
    transition: "transform 0.3s ease",
    transform: isHovered ? "scale(1.05)" : "scale(1)",
    boxShadow: isHovered
      ? "0 10px 25px rgba(0,0,0,0.1)"
      : "0 5px 15px rgba(0,0,0,0.08)",
  };
  const beforeStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    border: "2px solid transparent",
    background: "linear-gradient(45deg, #22348b, #344ed0, #4d67ea, #3a57e8)",
    backgroundSize: "300% 300%",
    borderRadius: "0.75rem",
    zIndex: -2,
    animation: "gradientMove 4s ease infinite",
  };
  const afterStyle = {
    position: "absolute",
    top: "2px",
    left: "2px",
    right: "2px",
    bottom: "2px",
    backgroundColor: "white",
    borderRadius: "10px",
    zIndex: -1,
  };
  const contentStyle = {
    position: "relative",
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
  };
  const textStyle = {
    fontWeight: "400",
    fontSize: "0.90rem",
    color: "#000",
    margin: 0,
  };
  const chevronStyle = {
    width: "1.15rem",
    height: "1.15rem",
    color: "#1215ca",
    transition: "transform 0.3s ease",
    transform: isTable3Open ? "rotate(270deg)" : "rotate(90deg)",
  };
  const tooltipStyle = {
    position: "absolute",
    bottom: "calc(100% + 10px)",
    left: "50%",
    transform: "translateX(-50%)",
    backgroundColor: "#1f2937",
    color: "white",
    padding: "0.5rem 0.75rem",
    borderRadius: "6px",
    fontSize: "0.8rem",
    fontWeight: "500",
    whiteSpace: "nowrap",
    zIndex: 1000,
    opacity: showTooltip && !isTable3Open ? 1 : 0,
    visibility: showTooltip && !isTable3Open ? "visible" : "hidden",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
  };
  const tooltipArrowStyle = {
    position: "absolute",
    top: "100%",
    left: "50%",
    transform: "translateX(-50%)",
    width: 0,
    height: 0,
    borderLeft: "6px solid transparent",
    borderRight: "6px solid transparent",
    borderTop: "6px solid #1f2937",
  };

  return (
    <>
      <div>
        <Modal
          show={showDiscardModal}
          onHide={handleCancelDiscard}
          backdrop="static"
          keyboard={false}
          centered
        >
          <Modal.Header className="custom-modal-header d-flex justify-content-center items-center relative">
            <Modal.Title>Unsaved Changes</Modal.Title>
            <button
              type="button"
              className="btn-close-svg"
              style={{ position: "absolute", right: "1rem" }}
              onClick={handleCancelDiscard}
              aria-label="Close"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              </svg>
            </button>
          </Modal.Header>
          <Modal.Body className="text-center px-4 pt-2">
            <p
              className="text-muted mb-4 px-2"
              style={{ fontSize: "1rem", lineHeight: "1.5" }}
            >
              You have unsaved products added to this order. Do you want to
              discard these changes?
            </p>
          </Modal.Body>
          <Modal.Footer className="border-0 justify-content-end pb-4 pt-0">
            <Button
              type="button"
              className="btn btn-white me-4"
              variant="btn btn-white"
              onClick={handleDiscardChanges}
              style={{
                borderRadius: "25px",
                fontWeight: "500",
                minWidth: "100px",
                borderColor: "#6c757d",
                color: "#6c757d",
              }}
            >
              Discard
            </Button>
            <Button
              className="px-4 py-2"
              style={{
                backgroundColor: "#3a57e8",
                borderColor: "#3a57e8",
                borderRadius: "25px",
                fontWeight: "500",
                minWidth: "100px",
              }}
              onClick={handleCancelDiscard}
            >
              Continue
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={itemViewModel}
          onHide={handleCloseView}
          backdrop="true"
          keyboard={true}
          size="lg"
        >
          <Modal.Header className="custom-modal-header">
            <Modal.Title>View Item</Modal.Title>
            <button
              type="button"
              className="btn-close-svg"
              onClick={handleCloseView}
              aria-label="Close"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              </svg>
            </button>
          </Modal.Header>
          <Formik initialValues={itemView} enableReinitialize>
            {({ values, handleChange }) => (
              <Form className="form-horizontal ps-3 pe-3">
                <Modal.Body>
                  <Row>
                    <Col sm="6">
                      <Form.Group>
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          readOnly
                          type="text"
                          value={values?.description || ""}
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm="6">
                      <Form.Group>
                        <Form.Label>Make</Form.Label>
                        <Form.Control
                          readOnly
                          type="text"
                          value={values?.manufacturer_name || ""}
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6">
                      <Form.Group>
                        <Form.Label>Model</Form.Label>
                        <Form.Control
                          readOnly
                          type="text"
                          value={values?.model || ""}
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm="6">
                      <Form.Group>
                        <Form.Label>SKU</Form.Label>
                        <Form.Control
                          readOnly
                          type="text"
                          value={values?.sku || ""}
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6">
                      <Form.Group>
                        <Form.Label>System</Form.Label>
                        <Form.Control
                          readOnly
                          type="text"
                          value={values?.system_name || ""}
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm="6">
                      <Form.Group>
                        <Form.Label>Phase</Form.Label>
                        <Form.Control
                          readOnly
                          type="text"
                          value={values?.phase_name || ""}
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6">
                      <Form.Group>
                        <Form.Label>Warehouse</Form.Label>
                        <Form.Control
                          readOnly
                          type="text"
                          value={values?.warehouse_name || ""}
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm="6">
                      <Form.Group>
                        <Form.Label>Job</Form.Label>
                        <Form.Control
                          readOnly
                          type="text"
                          value={values?.job_name || ""}
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12}>
                      <Form.Group>
                        <Form.Label>Ship To</Form.Label>
                        <Form.Control
                          readOnly
                          type="text"
                          value={values?.ship_to || ""}
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12}>
                      <Form.Group>
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          readOnly
                          as="textarea"
                          value={values?.description || ""}
                          onChange={handleChange}
                          style={{
                            resize: "none",
                            fontSize: "0.8rem",
                            cursor: "not-allowed",
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6">
                      <Form.Group>
                        <Form.Label>Quantity</Form.Label>
                        <Form.Control
                          type="text"
                          readOnly
                          value={values?.quantity ?? ""}
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm="6">
                      <Form.Group>
                        <Form.Label>Rate</Form.Label>
                        <Form.Control
                          type="text"
                          readOnly
                          value={values?.rate || ""}
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6">
                      <Form.Group>
                        <Form.Label>Amount</Form.Label>
                        <Form.Control
                          type="text"
                          readOnly
                          value={values?.amount || 0}
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Modal.Body>
              </Form>
            )}
          </Formik>
        </Modal>

        <Modal
          show={gpViewModal}
          onHide={() => {
            setGpViewModal(false);
            setGpViewItem(null);
          }}
          backdrop="true"
          keyboard={true}
          size="lg"
          style={{ zIndex: 99999 }}
        >
          <Modal.Header className="custom-modal-header">
            <Modal.Title>View Product</Modal.Title>
            <button
              type="button"
              className="btn-close-svg"
              onClick={() => {
                setGpViewModal(false);
                setGpViewItem(null);
              }}
              aria-label="Close"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              </svg>
            </button>
          </Modal.Header>
          <Modal.Body>
            {gpViewItem && (
              <>
                <Row>
                  <Col sm="6">
                    <Form.Group className="form-group">
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        value={gpViewItem.description || ""}
                        style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col sm="6">
                    <Form.Group className="form-group">
                      <Form.Label>Make</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        value={gpViewItem.manufacturerName || ""}
                        style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="6">
                    <Form.Group className="form-group">
                      <Form.Label>Model</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        value={gpViewItem.model || ""}
                        style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col sm="6">
                    <Form.Group className="form-group">
                      <Form.Label>SKU</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        value={gpViewItem.sku || ""}
                        style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Form.Group className="form-group">
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        readOnly
                        as="textarea"
                        value={gpViewItem.description || ""}
                        style={{
                          resize: "none",
                          fontSize: "0.8rem",
                          cursor: "not-allowed",
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="6">
                    <Form.Group className="form-group">
                      <Form.Label>Quantity</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        value={gpViewItem.quantity ?? ""}
                        style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col sm="6">
                    <Form.Group className="form-group">
                      <Form.Label>Rate</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        value={gpViewItem.rate ?? ""}
                        style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="6">
                    <Form.Group className="form-group">
                      <Form.Label>Amount</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        value={gpViewItem.amount ?? 0}
                        style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}
          </Modal.Body>
        </Modal>

        <Formik
          enableReinitialize
          initialValues={initialFormValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            handleChange,
            handleBlur,
            touched,
            setFieldValue,
            handleSubmit,
            isSubmitting,
            resetForm,
            errors: errorsFormik,
            setFieldError,
            setFieldTouched,
          }) => (
            <Form onSubmit={handleSubmit}>
              <FocusError />
              <Row>
                <Col xl="12" lg="12" ref={alertRef}>
                  <Card>
                    <Card.Header className="d-flex justify-content-between">
                      <div
                        className="breadcrumb header-title"
                        style={{ cursor: "pointer" }}
                      >
                        <h4
                          onClick={() =>
                            navigate("/dashboard/app/purchase-order-list")
                          }
                          className="text-primary card-title"
                          style={{ cursor: "pointer" }}
                        >
                          <span>Purchase Order </span>
                        </h4>
                        <h4 className="mx-2 card-title"> {">"} </h4>
                        <h4 className="card-title"> Add </h4>
                      </div>
                    </Card.Header>
                    <Card.Body>
                      <AlertNotificationSimple
                        type={alert.type}
                        message={alert.message}
                        show={alert.show}
                        onClose={() => setAlert({ ...alert, show: false })}
                      />
                      {!loader ? (
                        <>
                          <Row className="mb-4 new-order-info">
                            <Col md={8} className="d-flex align-items-end">
                              <Row md={12} style={{ width: "100%" }}>
                                <Col md={4}>
                                  <DatePickerField
                                    className="col-md-12 form-group"
                                    type="date"
                                    name="date"
                                    placeholder="Enter date"
                                    value={values.date}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    asterick
                                    errorMessage={errors?.date}
                                    label="Date"
                                    dateFormat="MM/dd/yyyy"
                                  />
                                </Col>
                                <Col md={4}>
                                  <InputField
                                    className="col-md-12 form-group"
                                    type="text"
                                    name="poNumber"
                                    placeholder="Enter PO # "
                                    value={values.poNumber}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    asterick
                                    errorMessage={errors?.poNumber}
                                    label="PO #"
                                  />
                                </Col>
                                <Col md={4}>
                                  <Form.Group className="col-md-12 form-group">
                                    <Form.Label>
                                      Vendor{" "}
                                      <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Select
                                      options={optionsVendorForPO}
                                      value={optionsVendorForPO.find(
                                        (o) => o.value === values.vendorId,
                                      )}
                                      onChange={(option) => {
                                        setFieldTouched("vendorId", true);
                                        setFieldValue(
                                          "vendorId",
                                          option?.value || null,
                                        );
                                      }}
                                      onBlur={() =>
                                        setFieldTouched("vendorId", true)
                                      }
                                      isClearable
                                      placeholder="Select Vendor"
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: (b) => ({
                                          ...b,
                                          zIndex: 9999,
                                        }),
                                        control: (b) => ({
                                          ...b,
                                          height: "45px",
                                          borderColor:
                                            errorsFormik.vendorId &&
                                            touched.vendorId
                                              ? "red"
                                              : b.borderColor,
                                        }),
                                      }}
                                    />
                                    {errorsFormik.vendorId &&
                                      touched.vendorId && (
                                        <div className="text-danger mt-1 small">
                                          {errorsFormik.vendorId}
                                        </div>
                                      )}
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                            <Col md={4}>
                              <Form.Group className="col-md-12 form-group">
                                <Form.Label
                                  className="d-flex"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  Ship To
                                  <span
                                    className="d-flex flex-row"
                                    style={{ width: "100%" }}
                                  >
                                    <span className="text-danger">* </span>
                                    <Select
                                      options={warehouseOptions}
                                      value={warehouseOptions.find(
                                        (o) => o.value === values.warehouseId,
                                      )}
                                      onChange={(option) => {
                                        const sel = warehouseOptions.find(
                                          (w) => w.value === option?.value,
                                        );
                                        setFieldValue(
                                          "warehouseId",
                                          option?.value,
                                        );
                                        const newShipTo = sel?.address || "";
                                        setFieldValue("shipTo", newShipTo);
                                        if (option?.value) {
                                          setFieldError(
                                            "warehouseId",
                                            undefined,
                                          );
                                          setFieldTouched("warehouseId", false);
                                          if (newShipTo) {
                                            setFieldError("shipTo", undefined);
                                            setFieldTouched("shipTo", false);
                                          }
                                          setErrors((prev) => {
                                            const n = { ...prev };
                                            delete n.warehouseId;
                                            delete n.shipTo;
                                            return n;
                                          });
                                        } else {
                                          setFieldError(
                                            "warehouseId",
                                            "Warehouse is required",
                                          );
                                          setFieldTouched("warehouseId", true);
                                        }
                                      }}
                                      isClearable
                                      placeholder={
                                        warehouseOptions.length === 0 ? (
                                          <span>No warehouse found</span>
                                        ) : (
                                          "Select Warehouse..."
                                        )
                                      }
                                      noOptionsMessage={() => (
                                        <div style={{ textAlign: "center" }}>
                                          <span style={{ color: "#666" }}>
                                            No warehouse found.
                                            {(warehouseHasCreatePermission ||
                                              decodedToken?.roles.some(
                                                (r) =>
                                                  r.role_type ===
                                                  roleTypes.SUPER_ADMIN,
                                              )) && (
                                              <span>
                                                {" "}
                                                <Link
                                                  to="/dashboard/app/warehouse-add"
                                                  style={{
                                                    color: "#007bff",
                                                    textDecoration: "none",
                                                  }}
                                                >
                                                  Add new
                                                </Link>
                                              </span>
                                            )}
                                          </span>
                                        </div>
                                      )}
                                      menuPortalTarget={document.body}
                                      menuPosition="fixed"
                                      menuPlacement="auto"
                                      className="display-content-dropdown"
                                      styles={{
                                        option: (b, s) => ({
                                          ...b,
                                          backgroundColor: s.isSelected
                                            ? "#007bff"
                                            : s.isFocused
                                              ? "#e6f7ff"
                                              : "#fff",
                                          color: "#333",
                                        }),
                                        control: (b) => ({
                                          ...b,
                                          marginLeft: "1rem",
                                          width: "100%",
                                        }),
                                        menuPortal: (b) => ({
                                          ...b,
                                          zIndex: 9999,
                                        }),
                                        menu: (b) => ({ ...b, zIndex: 9999 }),
                                      }}
                                    />
                                  </span>
                                </Form.Label>
                                <ErrorMessage
                                  name="warehouseId"
                                  component="div"
                                  className="text-danger text-end"
                                />
                                <Form.Control
                                  id="shipTo"
                                  as="textarea"
                                  name="shipTo"
                                  placeholder="Enter Shipment Address"
                                  value={values?.shipTo}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  style={{ resize: "none", height: "150px" }}
                                />
                                <ErrorMessage
                                  name="shipTo"
                                  component="div"
                                  className="text-danger"
                                />
                              </Form.Group>
                            </Col>
                          </Row>

                          <Row>
                            <Col sm={12} ref={alertRefProduct}>
                              <Card>
                                <Card.Body>
                                  <Row className="m-0 p-0 mb-3">
                                    <Col md={12} className="m-0 p-0">
                                      <Col
                                        xs={12}
                                        className="d-flex gap-4 flex-column flex-md-row justify-content-end"
                                      >
                                        <Button
                                          variant="primary"
                                          className="text-nowrap d-flex align-items-center gap-2"
                                          onClick={() =>
                                            setActivePanel((prev) =>
                                              prev === "general"
                                                ? "none"
                                                : "general",
                                            )
                                          }
                                          style={{ borderRadius: "0.5rem" }}
                                        >
                                          {showGeneralProductsPanel ? (
                                            <span>Hide New Products</span>
                                          ) : (
                                            <>
                                              <Plus
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                }}
                                              />
                                              <span>Add New Products</span>
                                            </>
                                          )}
                                        </Button>

                                        <div
                                          style={buttonContainerStyle}
                                          onClick={() =>
                                            setActivePanel((prev) =>
                                              prev === "requested"
                                                ? "none"
                                                : "requested",
                                            )
                                          }
                                          ref={popupRef}
                                          onMouseEnter={() =>
                                            setIsHovered(true)
                                          }
                                          onMouseLeave={() =>
                                            setIsHovered(false)
                                          }
                                        >
                                          <div style={buttonStyle}>
                                            <div style={beforeStyle} />
                                            <div style={afterStyle} />
                                            <div style={contentStyle}>
                                              {!isTable3Open && (
                                                <Plus
                                                  className="text-primary"
                                                  style={{
                                                    width: "1.25rem",
                                                    height: "1.25rem",
                                                  }}
                                                />
                                              )}
                                              <span style={textStyle}>
                                                {isTable3Open
                                                  ? "Hide Requested Products"
                                                  : "Show Requested Products"}
                                              </span>
                                              <ChevronDown
                                                className="text-primary"
                                                style={chevronStyle}
                                              />
                                            </div>
                                          </div>
                                          <div style={tooltipStyle}>
                                            Click here to add products to this
                                            order
                                            <div style={tooltipArrowStyle} />
                                          </div>
                                        </div>

                                        <style>{`
                                          @keyframes gradientMove { 0%,100%{background-position:0% 50%} 25%{background-position:100% 50%} 50%{background-position:100% 100%} 75%{background-position:0% 100%} }
                                          @keyframes pulse { 0%,100%{transform:scale(1);opacity:1} 50%{transform:scale(1.1);opacity:0.8} }
                                        `}</style>
                                      </Col>
                                    </Col>
                                  </Row>

                                  <Row
                                    className="d-flex"
                                    ref={containerRef}
                                    style={{
                                      flexDirection: isMobile
                                        ? "column"
                                        : "row",
                                      flexWrap: isMobile ? "wrap" : "nowrap",
                                      position: "relative",
                                    }}
                                  >
                                    <Col
                                      md="auto"
                                      sm={12}
                                      className="m-0 p-0"
                                      style={{
                                        width: isMobile
                                          ? "100%"
                                          : isRightPanelOpen
                                            ? `calc(${leftWidth}% - 5px)`
                                            : "100%",
                                        transition: isResizing
                                          ? "none"
                                          : "width 0.5s ease-in-out",
                                      flex: isMobile
                                          ? "1 1 auto"
                                          : "0 0 auto",
                                      }}
                                    >
                                       <Card.Header className="d-flex flex-column ps-0">
                                         <div className="header-title w-100 mb-3">
                                           <h5 className="card-title">
                                             Order Products
                                           </h5>
                                         </div>

                                        {orderProducts.length > 0 && (
                                          <Row className="mb-3 g-2 mt-2 w-100">
                                            <Col md={4} sm={12}>
                                              <Select
                                                options={gpOptionsJob}
                                                value={gpOptionsJob.find((o) => o.value === gpSelectedJobId) || null}
                                                onChange={async (opt) => {
                                                  const newJobId = opt?.value || null;
                                                  setGpSelectedJobId(newJobId);
                                                  setBulkJobId(newJobId);
                                                  
                                                  setGpSelectedSystemId(null);
                                                  setBulkSystemId(null);
                                                  setGpSelectedPhaseId(null);
                                                  setBulkPhaseId(null);
                                                  
                                                  setGpSystemOptions([]);
                                                  setGpPhaseOptions([]);

                                                  const applyToOrder = (jid, sid, pid) => {
                                                    setOrderProducts(prev => prev.map(p => {
                                                      if (p.product_request_id || p.job_id) return p;
                                                      
                                                      const update = { ...p };
                                                      let changed = false;

                                                      if (jid && !p.job_id) {
                                                        const jobOpt = gpOptionsJob.find(o => o.value === jid);
                                                        update.job_id = jid;
                                                        update.job_name = jobOpt?.label || "";
                                                        update.site_name = jobOpt?.siteName || "";
                                                        changed = true;
                                                      }
                                                      
                                                      if (sid && !p.system_id && update.job_id === jid) {
                                                        update.system_id = sid;
                                                        changed = true;
                                                      }

                                                      if (pid && !p.phase_id && update.system_id === sid) {
                                                        update.phase_id = pid;
                                                        changed = true;
                                                      }

                                                      return changed ? update : p;
                                                    }));
                                                  };

                                                  if (newJobId) {
                                                    setGpLoadingSystems(true);
                                                    try {
                                                      let jd = jobSystemsPhasesMap[newJobId];
                                                      if (!jd) jd = await fetchJobSystemsPhases(newJobId);
                                                      if (jd?.systems) {
                                                        const systems = jd.systems.map((s) => ({
                                                          value: s.system_id,
                                                          label: s.system_name,
                                                          phases: s.phases,
                                                        }));
                                                        setGpSystemOptions(systems);
                                                        
                                                        let finalSysId = null;
                                                        let finalPhaseId = null;

                                                        if (jd.active_system_id) {
                                                          finalSysId = jd.active_system_id;
                                                          setGpSelectedSystemId(finalSysId);
                                                          setBulkSystemId(finalSysId);
                                                          
                                                          const activeSys = systems.find((s) => s.value === finalSysId);
                                                          if (activeSys?.phases && jd.active_phase_id) {
                                                            finalPhaseId = jd.active_phase_id;
                                                            setGpPhaseOptions(activeSys.phases.map((p) => ({
                                                              value: p.phase_id,
                                                              label: p.phase_name,
                                                            })));
                                                            setGpSelectedPhaseId(finalPhaseId);
                                                            setBulkPhaseId(finalPhaseId);
                                                          }
                                                        }
                                                        applyToOrder(newJobId, finalSysId, finalPhaseId);
                                                      } else {
                                                        applyToOrder(newJobId, null, null);
                                                      }
                                                    } finally {
                                                      setGpLoadingSystems(false);
                                                    }
                                                  } else {
                                                    applyToOrder(null, null, null);
                                                  }
                                                }}
                                                isClearable
                                                isDisabled={gpLoadingInitial || gpLoadingSystems}
                                                isLoading={gpLoadingSystems}
                                                placeholder="Select Job"
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                menuPlacement="auto"
                                                styles={{
                                                  container: (b) => ({ ...b, width: "100%" }),
                                                  option: (b, s) => ({
                                                    ...b,
                                                    backgroundColor: s.isSelected ? "#007bff" : s.isFocused ? "#e6f7ff" : "#fff",
                                                    color: "#333",
                                                    fontSize: "0.8rem",
                                                  }),
                                                  menuPortal: (b) => ({ ...b, zIndex: 9999 }),
                                                  menu: (b) => ({ ...b, zIndex: 9999 }),
                                                }}
                                              />
                                            </Col>
                                            <Col md={4} sm={12}>
                                              <Select
                                                options={gpSystemOptions}
                                                value={gpSystemOptions.find((o) => o.value === gpSelectedSystemId) || null}
                                                onChange={(opt) => {
                                                  const newSysId = opt?.value || null;
                                                  setGpSelectedSystemId(newSysId);
                                                  setBulkSystemId(newSysId);
                                                  setGpSelectedPhaseId(null);
                                                  setBulkPhaseId(null);
                                                  if (!newSysId) setGpPhaseOptions([]);
                                                  else {
                                                    const sys = gpSystemOptions.find((s) => s.value === newSysId);
                                                    if (sys?.phases)
                                                      setGpPhaseOptions(sys.phases.map((p) => ({
                                                        value: p.phase_id,
                                                        label: p.phase_name,
                                                      })));
                                                  }
                                                  setOrderProducts(prev => prev.map(p => {
                                                    if (p.product_request_id || p.job_id !== gpSelectedJobId || p.system_id) return p;
                                                    return { ...p, system_id: newSysId, phase_id: null };
                                                  }));
                                                }}
                                                isClearable
                                                isDisabled={!gpSelectedJobId || gpLoadingInitial || gpLoadingSystems}
                                                isLoading={gpLoadingSystems}
                                                placeholder={!gpSelectedJobId ? "Select job first" : "Select System"}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                menuPlacement="auto"
                                                styles={{
                                                  container: (b) => ({ ...b, width: "100%" }),
                                                  option: (b, s) => ({
                                                    ...b,
                                                    backgroundColor: s.isSelected ? "#007bff" : s.isFocused ? "#e6f7ff" : "#fff",
                                                    color: "#333",
                                                    fontSize: "0.8rem",
                                                  }),
                                                  menuPortal: (b) => ({ ...b, zIndex: 9999 }),
                                                  menu: (b) => ({ ...b, zIndex: 9999 }),
                                                  placeholder: (b) => ({ ...b, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }),
                                                }}
                                              />
                                            </Col>
                                            <Col md={4} sm={12}>
                                              <Select
                                                options={gpPhaseOptions}
                                                value={gpPhaseOptions.find((o) => o.value === gpSelectedPhaseId) || null}
                                                onChange={(opt) => {
                                                  const newPhaseId = opt?.value || null;
                                                  setGpSelectedPhaseId(newPhaseId);
                                                  setBulkPhaseId(newPhaseId);
                                                  setOrderProducts(prev => prev.map(p => {
                                                    if (p.product_request_id || p.system_id !== gpSelectedSystemId || p.phase_id) return p;
                                                    return { ...p, phase_id: newPhaseId };
                                                  }));
                                                }}
                                                isClearable
                                                isDisabled={!gpSelectedSystemId || gpLoadingInitial || gpLoadingSystems}
                                                placeholder={!gpSelectedSystemId ? "Select system first" : "Select Phase"}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                menuPlacement="auto"
                                                styles={{
                                                  container: (b) => ({ ...b, width: "100%" }),
                                                  option: (b, s) => ({
                                                    ...b,
                                                    backgroundColor: s.isSelected ? "#007bff" : s.isFocused ? "#e6f7ff" : "#fff",
                                                    color: "#333",
                                                    fontSize: "0.8rem",
                                                  }),
                                                  menuPortal: (b) => ({ ...b, zIndex: 9999 }),
                                                  menu: (b) => ({ ...b, zIndex: 9999 }),
                                                  placeholder: (b) => ({ ...b, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }),
                                                }}
                                              />
                                            </Col>
                                          </Row>
                                        )}
                                       </Card.Header>
                                      <Card.Body className="ps-0 pe-0">
                                        {validationErrors && typeof validationErrors === "string" && (
                                          <span className="w-100 mt-1 small text-danger">
                                            {validationErrors}
                                            <br />
                                          </span>
                                        )}
                                        {validationErrors && typeof validationErrors === "object" && Object.keys(validationErrors).length > 0 && (
                                          <span className="w-100 mt-1 small text-danger d-block mb-2">
                                          Rate must be greater than 0
                                            <br />
                                          </span>
                                        )}
                                        <Box
                                          sx={{
                                            pt: "4px",
                                            width: "100%",
                                            marginTop : "0rem"
                                            
                                          }}
                                        >
                                          <MaterialReactTable
                                            table={tableOrderProduct}
                                          />
                                          <div style={{ marginTop: "2rem" }} />
                                          <hr className="order-button" />
                                          <div
                                            className="order-button flex-wrap flex-md-nowrap justify-content-end gap-1 gap-md-2"
                                            style={{ marginTop: "2rem" }}
                                          >
                                            <Button
                                              type="button"
                                              className="me-2 me-md-5 px-3 px-md-4"
                                              variant="btn btn-light"
                                              onClick={() => {
                                                resetForm();
                                                setOrderProducts([]);
                                                setHasUnsavedChanges(false);
                                              }}
                                            >
                                              Reset
                                            </Button>
                                            <Button
                                              type="submit"
                                              disabled={isSubmitting}
                                              variant="btn btn-primary"
                                              className="me-2 me-md-5 px-3 px-md-4"
                                            >
                                              Submit
                                            </Button>
                                            <Button
                                              type="button"
                                              className="px-3 px-md-4"
                                              variant="btn btn-danger"
                                              onClick={() =>
                                                navigate(
                                                  "/dashboard/app/purchase-order-list",
                                                )
                                              }
                                            >
                                              Cancel
                                            </Button>
                                          </div>
                                        </Box>
                                      </Card.Body>
                                    </Col>

                                    {!isMobile && isRightPanelOpen && (
                                      <Tooltip
                                        title="Drag left or right to resize tables"
                                        placement="top"
                                        arrow
                                      >
                                        <div
                                          onMouseDown={startResizing}
                                          style={{
                                            width: "16px",
                                            cursor: "col-resize",
                                            zIndex: 10,
                                            flex: "0 0 auto",
                                            position: "relative",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            background: isResizing
                                              ? "rgba(0,123,255,0.05)"
                                              : "transparent",
                                            transition: "background 0.3s",
                                          }}
                                          className="resizer-handle"
                                        >
                                          <div
                                            style={{
                                              width: "1px",
                                              height: "78%",
                                              borderLeft: isResizing
                                                ? "2px solid #007bff"
                                                : "2px dotted #adb5bd",
                                              opacity: isResizing ? 1 : 0.6,
                                              transition: "all 0.3s",
                                              position: "absolute",
                                            }}
                                          />
                                          <div
                                            style={{
                                              width: "16px",
                                              height: "40px",
                                              borderRadius: "4px",
                                              background: isResizing
                                                ? "#007bff"
                                                : "#fff",
                                              border: isResizing
                                                ? "1px solid #007bff"
                                                : "1px solid #adb5bd",
                                              zIndex: 11,
                                              display: "flex",
                                              flexDirection: "column",
                                              justifyContent: "space-evenly",
                                              alignItems: "center",
                                              boxShadow:
                                                "0 2px 4px rgba(0,0,0,0.1)",
                                              transition: "all 0.3s",
                                            }}
                                          >
                                            {[0, 1, 2].map((i) => (
                                              <div
                                                key={i}
                                                style={{
                                                  width: "2px",
                                                  height: "2px",
                                                  borderRadius: "50%",
                                                  background: isResizing
                                                    ? "#fff"
                                                    : "#adb5bd",
                                                }}
                                              />
                                            ))}
                                          </div>
                                        </div>
                                      </Tooltip>
                                    )}

                                    <Col
                                      md="auto"
                                      sm={12}
                                      className="m-0 p-0"
                                      style={{
                                        width: isMobile
                                          ? isRightPanelOpen
                                            ? "100%"
                                            : "0%"
                                          : isRightPanelOpen
                                            ? `calc(${100 - leftWidth}% - 5px)`
                                            : "0%",
                                        height: isRightPanelOpen
                                          ? "auto"
                                          : "0px",
                                        opacity: isRightPanelOpen ? 1 : 0,
                                        transition: isResizing
                                          ? "none"
                                          : "width 0.5s ease-in-out, opacity 0.3s ease-in-out",
                                        overflow: "hidden",
                                        visibility: isRightPanelOpen
                                          ? "visible"
                                          : "hidden",
                                        maxWidth: isMobile
                                          ? "100%"
                                          : isRightPanelOpen
                                            ? `calc(${100 - leftWidth}% - 5px)`
                                            : "0%",
                                        flex: isMobile
                                          ? "1 1 auto"
                                          : "0 0 auto",
                                      }}
                                    >
                                      <div
                                        style={{
                                          opacity: isRightPanelOpen ? 1 : 0,
                                          transform: isRightPanelOpen
                                            ? "translateX(0)"
                                            : "translateX(20px)",
                                          transition:
                                            "opacity 0.4s ease-in-out, transform 0.4s ease-in-out",
                                        }}
                                      >
                                        {activePanel === "requested" && (
                                          <>
                                            <Card.Header className="d-flex justify-content-between ps-0">
                                              <div className="header-title">
                                                <h5 className="card-title">
                                                  Requested Products
                                                </h5>
                                                <p className="card-title">
                                                  Drag product from here into
                                                  order form
                                                </p>
                                              </div>
                                              <Col
                                                md={5}
                                                className="d-flex flex-row justify-content-end align-items-center mb-3"
                                              >
                                                <Form.Label
                                                  className="text-nowrap me-2 mt-1"
                                                  style={{ fontSize: "16px" }}
                                                >
                                                  Filter by{" "}
                                                </Form.Label>
                                                <Select
                                                  options={optionsVendor}
                                                  value={optionsVendor.find(
                                                    (o) => o.value === vendorId,
                                                  )}
                                                  onChange={(option) => {
                                                    setVendorId(
                                                      option?.value || "all",
                                                    );
                                                    setPagination({
                                                      pageIndex: 0,
                                                      pageSize: 20,
                                                    });
                                                  }}
                                                  isClearable
                                                  placeholder="Select Vendor"
                                                  styles={{
                                                    container: (b) => ({
                                                      ...b,
                                                      width: "100%",
                                                    }),
                                                    option: (b, s) => ({
                                                      ...b,
                                                      backgroundColor:
                                                        s.isSelected
                                                          ? "#007bff"
                                                          : s.isFocused
                                                            ? "#e6f7ff"
                                                            : "#fff",
                                                      color: "#333",
                                                      fontSize: "0.8rem",
                                                    }),
                                                    menuPortal: (b) => ({
                                                      ...b,
                                                      zIndex: 9999,
                                                    }),
                                                    menu: (b) => ({
                                                      ...b,
                                                      zIndex: 9999,
                                                    }),
                                                  }}
                                                />
                                              </Col>
                                            </Card.Header>
                                            <Card.Body className="pe-0 ps-1">
                                              <Box
                                                sx={{
                                                  width: "100%",
                                                  whiteSpace: "nowrap",
                                                     marginTop:
                                              activePanel === "requested"
                                                ? "3.8rem"
                                                : activePanel === "general"
                                                  ? "3.8rem"
                                                  : "3.8rem",
                                                }}
                                              >
                                                <MaterialReactTable
                                                  table={tableProduct}
                                                />
                                                <Popover
                                                  open={dragPopoverOpen}
                                                  anchorEl={dragPopoverAnchor}
                                                  disableScrollLock
                                                  disableAutoFocus
                                                  disableEnforceFocus
                                                  onClose={() =>
                                                    setDragPopoverOpen(false)
                                                  }
                                                  anchorOrigin={{
                                                    vertical: "top",
                                                    horizontal: "right",
                                                  }}
                                                  transformOrigin={{
                                                    vertical: "center",
                                                    horizontal: "left",
                                                  }}
                                                  sx={{
                                                    pointerEvents: "none",
                                                  }}
                                                  PaperProps={{
                                                    sx: {
                                                      px: 1.5,
                                                      py: 0.5,
                                                      backgroundColor: "#333",
                                                      color: "white",
                                                      fontSize: "0.75rem",
                                                      borderRadius: "4px",
                                                      boxShadow:
                                                        "0px 4px 12px rgba(0,0,0,0.3)",
                                                    },
                                                  }}
                                                >
                                                  <Typography variant="caption">
                                                    Drag to move
                                                  </Typography>
                                                </Popover>
                                                <Popover
                                                  open={
                                                    !dragPopoverOpen &&
                                                    rowHoverPopoverOpen
                                                  }
                                                  anchorEl={
                                                    rowHoverPopoverAnchor
                                                  }
                                                  disableScrollLock
                                                  disableAutoFocus
                                                  disableEnforceFocus
                                                  disableRestoreFocus
                                                  onClose={() => {
                                                    setRowHoverPopoverOpen(
                                                      false,
                                                    );
                                                    setRowHoverPopoverAnchor(
                                                      null,
                                                    );
                                                    setHoveredRowId(null);
                                                    if (hoverTimeoutRef.current)
                                                      clearTimeout(
                                                        hoverTimeoutRef.current,
                                                      );
                                                  }}
                                                  anchorReference="anchorPosition"
                                                  anchorPosition={{
                                                    top: mousePosition.y - 10,
                                                    left: mousePosition.x,
                                                  }}
                                                  transformOrigin={{
                                                    vertical: "bottom",
                                                    horizontal: "left",
                                                  }}
                                                  sx={{
                                                    pointerEvents: "none",
                                                    "& .MuiPaper-root": {
                                                      transform:
                                                        "translateX(-50%)",
                                                    },
                                                  }}
                                                  PaperProps={{
                                                    sx: {
                                                      px: 1.5,
                                                      py: 0.5,
                                                      backgroundColor: "#333",
                                                      color: "white",
                                                      fontSize: "0.75rem",
                                                      borderRadius: "4px",
                                                      boxShadow:
                                                        "0px 4px 12px rgba(0,0,0,0.3)",
                                                    },
                                                  }}
                                                >
                                                  <Typography variant="caption">
                                                    Click or drag to move
                                                  </Typography>
                                                </Popover>
                                              </Box>
                                            </Card.Body>
                                          </>
                                        )}

                                        {activePanel === "general" && (
                                          <div style={{ marginTop: "0.5rem" }}>
                                             <Card.Header className="d-flex justify-content-between align-items-start ps-0 pt-2 pb-3 flex-wrap gap-2">
                                               <div className="header-title">
                                                 <h5 className="card-title">
                                                   General Products List
                                                 </h5>
                                                 <p className="card-title">
                                                  Drag product from here into order form
                                                 </p>
                                               </div>
                                               <Col
                                                 md={5}
                                                 className="d-flex flex-row justify-content-end align-items-center mb-3"
                                               >
                                                 <Form.Label
                                                   className="text-nowrap me-2 mt-1"
                                                   style={{ fontSize: "16px" }}
                                                 >
                                                   Filter by{" "}
                                                 </Form.Label>
                                                 <Select
                                                   options={optionsVendor}
                                                   value={optionsVendor.find(
                                                     (o) => o.value === vendorId,
                                                   )}
                                                   onChange={(option) => {
                                                     setVendorId(
                                                       option?.value || "all",
                                                     );
                                                   }}
                                                   isClearable
                                                   placeholder="Select Vendor"
                                                   styles={{
                                                     container: (b) => ({
                                                       ...b,
                                                       width: "100%",
                                                     }),
                                                     option: (b, s) => ({
                                                       ...b,
                                                       backgroundColor:
                                                         s.isSelected
                                                           ? "#007bff"
                                                           : s.isFocused
                                                             ? "#e6f7ff"
                                                             : "#fff",
                                                       color: "#333",
                                                       fontSize: "0.8rem",
                                                     }),
                                                     menuPortal: (b) => ({
                                                       ...b,
                                                       zIndex: 9999,
                                                     }),
                                                     menu: (b) => ({
                                                       ...b,
                                                       zIndex: 9999,
                                                     }),
                                                   }}
                                                 />
                                               </Col>
                                             </Card.Header>
                                            <Card.Body className="ps-0 pe-0 pt-0">
                                              <Box
                                                sx={{
                                                  width: "100%",
                                                              marginTop:
                                              activePanel === "requested"
                                                ? "3.8rem"
                                                : activePanel === "general"
                                                  ? "4.7rem"
                                                  : "3.8rem",
                                                  overflow: "visible",
                                                  "& .MuiToolbar-root": {
                                                    minHeight:
                                                      "auto !important",
                                                    py: "8px",
                                                  },
                                                }}
                                              >
                                                <MaterialReactTable
                                                  table={tableGeneralProduct}
                                                />
                                              </Box>
                                            </Card.Body>
                                          </div>
                                        )}
                                      </div>
                                    </Col>
                                    <hr className="order-bottom-button" />
                                  </Row>
                                </Card.Body>
                              </Card>
                            </Col>
                          </Row>

                          <div className="order-bottom-button flex-wrap flex-md-nowrap justify-content-end gap-1 gap-md-2">
                            <Button
                              type="button"
                              className="me-2 me-md-5 px-3 px-md-4"
                              variant="btn btn-light"
                              onClick={() => {
                                resetForm();
                                setOrderProducts([]);
                                setHasUnsavedChanges(false);
                              }}
                            >
                              Reset
                            </Button>
                            <Button
                              type="submit"
                              disabled={isSubmitting}
                              variant="btn btn-primary"
                              className="me-2 me-md-5 px-3 px-md-4"
                            >
                              Submit
                            </Button>
                            <Button
                              type="button"
                              className="px-3 px-md-4"
                              variant="btn btn-danger"
                              onClick={() =>
                                navigate("/dashboard/app/purchase-order-list")
                              }
                            >
                              Cancel
                            </Button>
                          </div>
                        </>
                      ) : (
                        loader && <FadeLoaderComponent />
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default OrderRequestAdd;
